var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var BottomSheetSwipeClose = function () {
            function BottomSheetSwipeClose(modal, elems) {
                var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                _classCallCheck(this, BottomSheetSwipeClose);

                this.modal = modal;
                this.elems = elems || {};
                this.onClose = typeof onClose === 'function' ? onClose : null;

                this.startY = 0;
                this.startX = 0;
                this.startScrollTop = 0;
                this.lastY = 0;
                this.lastMoveAt = 0;
                this.prevY = 0;
                this.prevMoveAt = 0;
                this.currentOffset = 0;

                this.isPotentialDrag = false;
                this.isDragging = false;
                this.isClosing = false;
                this.resetAnimationTimer = null;

                this.onTouchStart = this.handleTouchStart.bind(this);
                this.onTouchMove = this.handleTouchMove.bind(this);
                this.onTouchEnd = this.handleTouchEnd.bind(this);
                this.onTouchCancel = this.handleTouchCancel.bind(this);
            }

            _createClass(BottomSheetSwipeClose, [{
                key: "init",
                value: function init() {
                    if (!this.isEnabled() || !this.modal) {
                        return;
                    }

                    this.modal.addEventListener('touchstart', this.onTouchStart, { passive: true });
                    this.modal.addEventListener('touchmove', this.onTouchMove, { passive: false });
                    this.modal.addEventListener('touchend', this.onTouchEnd, { passive: true });
                    this.modal.addEventListener('touchcancel', this.onTouchCancel, { passive: true });
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                        _ref$preserveStyles = _ref.preserveStyles,
                        preserveStyles = _ref$preserveStyles === undefined ? false : _ref$preserveStyles;

                    if (!this.modal) {
                        return;
                    }

                    this.modal.removeEventListener('touchstart', this.onTouchStart);
                    this.modal.removeEventListener('touchmove', this.onTouchMove);
                    this.modal.removeEventListener('touchend', this.onTouchEnd);
                    this.modal.removeEventListener('touchcancel', this.onTouchCancel);

                    if (this.resetAnimationTimer) {
                        clearTimeout(this.resetAnimationTimer);
                        this.resetAnimationTimer = null;
                    }

                    this.resetState();
                    if (!preserveStyles) {
                        this.resetStyles();
                    }
                }
            }, {
                key: "isEnabled",
                value: function isEnabled() {
                    return !!(this.modal && this.modal.classList && this.modal.classList.contains('modal2--bottom') && this.elems.content);
                }
            }, {
                key: "handleTouchStart",
                value: function handleTouchStart(event) {
                    if (!this.isEnabled() || this.isClosing || !event.touches || event.touches.length !== 1) {
                        return;
                    }

                    var touch = event.touches[0];
                    var target = event.target instanceof Element ? event.target : null;
                    if (!target || !this.isAllowedStartTarget(target, touch.clientY)) {
                        return;
                    }

                    var scrollTop = this.getScrollTop();
                    if (scrollTop > 0) {
                        return;
                    }

                    this.startY = touch.clientY;
                    this.startX = touch.clientX;
                    this.lastY = touch.clientY;
                    this.lastMoveAt = Date.now();
                    this.prevY = touch.clientY;
                    this.prevMoveAt = this.lastMoveAt;
                    this.startScrollTop = scrollTop;
                    this.currentOffset = 0;
                    this.isPotentialDrag = true;
                    this.isDragging = false;
                }
            }, {
                key: "handleTouchMove",
                value: function handleTouchMove(event) {
                    if (!this.isPotentialDrag && !this.isDragging || !event.touches || event.touches.length !== 1) {
                        return;
                    }

                    var touch = event.touches[0];
                    var deltaY = touch.clientY - this.startY;
                    var deltaX = touch.clientX - this.startX;

                    this.prevY = this.lastY;
                    this.prevMoveAt = this.lastMoveAt;
                    this.lastY = touch.clientY;
                    this.lastMoveAt = Date.now();

                    if (!this.isDragging) {
                        if (Math.abs(deltaY) < BottomSheetSwipeClose.DRAG_START_PX) {
                            return;
                        }

                        if (Math.abs(deltaX) > Math.abs(deltaY) || deltaY <= 0 || this.startScrollTop > 0 || this.getScrollTop() > 0) {
                            this.resetState();
                            return;
                        }

                        this.beginDrag();
                    }

                    event.preventDefault();

                    var offset = Math.max(0, deltaY);
                    this.currentOffset = offset;
                    this.render(offset);
                }
            }, {
                key: "handleTouchEnd",
                value: function handleTouchEnd() {
                    if (!this.isDragging) {
                        this.resetState();
                        return;
                    }

                    var dragDuration = Math.max(1, this.lastMoveAt - this.prevMoveAt);
                    var velocity = Math.max(0, this.lastY - this.prevY) / dragDuration;
                    var shouldClose = this.currentOffset >= this.getCloseDistance() || velocity >= BottomSheetSwipeClose.CLOSE_VELOCITY_PX_PER_MS;

                    if (shouldClose) {
                        this.closeWithAnimation();
                        return;
                    }

                    this.rollback();
                }
            }, {
                key: "handleTouchCancel",
                value: function handleTouchCancel() {
                    if (this.isDragging) {
                        this.rollback();
                        return;
                    }

                    this.resetState();
                }
            }, {
                key: "isAllowedStartTarget",
                value: function isAllowedStartTarget(target, clientY) {
                    if (this.elems.header && this.elems.header.contains(target)) {
                        return true;
                    }

                    if (!this.elems.content || !this.elems.content.contains(target)) {
                        return false;
                    }

                    var contentRect = this.elems.content.getBoundingClientRect();
                    return clientY <= contentRect.top + BottomSheetSwipeClose.START_ZONE_PX;
                }
            }, {
                key: "beginDrag",
                value: function beginDrag() {
                    this.isDragging = true;
                    this.modal.classList.add('modal2--swipe-dragging');

                    if (this.elems.content) {
                        this.elems.content.style.transition = 'none';
                        this.elems.content.style.willChange = 'transform';
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = 'none';
                        this.elems.footer.style.willChange = 'transform';
                    }
                    if (this.getOverlay()) {
                        this.getOverlay().style.transition = 'none';
                        this.getOverlay().style.willChange = 'opacity';
                    }
                }
            }, {
                key: "render",
                value: function render(offset) {
                    if (this.elems.content) {
                        this.elems.content.style.transform = "translateY(" + offset + "px)";
                    }

                    if (this.elems.footer) {
                        this.elems.footer.style.transform = "translateY(" + offset + "px)";
                    }

                    var overlay = this.getOverlay();
                    if (overlay) {
                        var opacity = Math.max(0, 1 - offset / Math.max(this.getContentHeight(), 1) * 1.6);
                        overlay.style.opacity = "" + opacity;
                    }
                }
            }, {
                key: "rollback",
                value: function rollback() {
                    var _this = this;

                    this.resetState();
                    this.animateTo(0, function () {
                        _this.modal.classList.remove('modal2--swipe-dragging');
                        _this.resetStyles();
                    });
                }
            }, {
                key: "closeWithAnimation",
                value: function closeWithAnimation() {
                    var _this2 = this;

                    if (this.isClosing) {
                        return;
                    }

                    this.isClosing = true;
                    this.resetState();
                    this.modal.dataset.swipeClosing = '1';

                    this.animateTo(window.innerHeight, function () {
                        if (_this2.onClose) {
                            _this2.onClose();
                        }
                    }, true);
                }
            }, {
                key: "animateTo",
                value: function animateTo(offset, onComplete) {
                    var _this3 = this;

                    var hideOverlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                    var transition = "transform " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease, opacity " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease";
                    var overlay = this.getOverlay();

                    if (this.elems.content) {
                        this.elems.content.style.transition = transition;
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = transition;
                    }
                    if (overlay) {
                        overlay.style.transition = "opacity " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease";
                    }

                    requestAnimationFrame(function () {
                        if (_this3.elems.content) {
                            _this3.elems.content.style.transform = offset > 0 ? "translateY(" + offset + "px)" : '';
                        }
                        if (_this3.elems.footer) {
                            _this3.elems.footer.style.transform = offset > 0 ? "translateY(" + offset + "px)" : '';
                        }
                        if (overlay) {
                            overlay.style.opacity = hideOverlay ? '0' : '';
                        }
                    });

                    this.resetAnimationTimer = setTimeout(function () {
                        _this3.resetAnimationTimer = null;
                        if (typeof onComplete === 'function') {
                            onComplete();
                        }
                    }, BottomSheetSwipeClose.CLOSE_ANIMATION_MS);
                }
            }, {
                key: "getCloseDistance",
                value: function getCloseDistance() {
                    return Math.min(140, Math.max(80, Math.round(this.getContentHeight() * 0.22)));
                }
            }, {
                key: "getContentHeight",
                value: function getContentHeight() {
                    return this.elems.content ? this.elems.content.getBoundingClientRect().height : window.innerHeight;
                }
            }, {
                key: "getOverlay",
                value: function getOverlay() {
                    return this.modal ? this.modal.querySelector('.modal2-overlay') : null;
                }
            }, {
                key: "getScrollTop",
                value: function getScrollTop() {
                    return this.elems.content ? this.elems.content.scrollTop : 0;
                }
            }, {
                key: "resetState",
                value: function resetState() {
                    this.isPotentialDrag = false;
                    this.isDragging = false;
                    this.currentOffset = 0;
                }
            }, {
                key: "resetStyles",
                value: function resetStyles() {
                    var overlay = this.getOverlay();

                    if (this.elems.content) {
                        this.elems.content.style.transition = '';
                        this.elems.content.style.transform = '';
                        this.elems.content.style.willChange = '';
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = '';
                        this.elems.footer.style.transform = '';
                        this.elems.footer.style.willChange = '';
                    }
                    if (overlay) {
                        overlay.style.transition = '';
                        overlay.style.opacity = '';
                        overlay.style.willChange = '';
                    }

                    if (this.modal) {
                        this.modal.classList.remove('modal2--swipe-dragging');
                    }
                }
            }], [{
                key: "START_ZONE_PX",
                get: function get() {
                    return 50;
                }
            }, {
                key: "DRAG_START_PX",
                get: function get() {
                    return 6;
                }
            }, {
                key: "CLOSE_VELOCITY_PX_PER_MS",
                get: function get() {
                    return 0.45;
                }
            }, {
                key: "CLOSE_ANIMATION_MS",
                get: function get() {
                    return 220;
                }
            }]);

            return BottomSheetSwipeClose;
        }();

        module.exports = BottomSheetSwipeClose;
    }, {}], 2: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var MODAL_IN_CSS_CLASS = 'in';
        var OVERFLOW_HIDDEN_CSS_CLASS = 'overflow-hidden';
        var BottomSheetSwipeClose = require('./BottomSheetSwipeClose');

        // TODO: добавить события начала и конца анимации показа/скрытия
        // Иногда нужно для того же сафари
        var events = {
            // Модалка создана и вставлена в DOM
            beforeShow: 'show.modal',
            // В модалку вставлен/загружен контент.
            // Анимация еще может быть не завершена или только начинаться
            afterShow: 'shown.modal',
            // Запущено закрытие модалки (старт)
            beforeHide: 'hide.modal',
            // Сразу по окончании анимации закрытия,
            // (До возвращения detachSelectorId контента в DOM и до удаления самой модалки из DOM)
            afterHide: 'hidden.modal'
        };

        var ModalItem = function () {
            /**
             * @param {HtModalOptions} params
             */
            function ModalItem(params) {
                _classCallCheck(this, ModalItem);

                this.params = params;
                if (params.content.htmlDetachSelectorId.length) {
                    var content = document.getElementById(params.content.htmlDetachSelectorId);
                    this.contentDetachedParent = content.parentNode;
                    this.content = this.content = content.parentNode.removeChild(content); // Detach the content
                } else {
                    this.content = params.content.html;
                    this.contentDetachedParent = null;
                }

                this.modal = document.querySelector(this.getTargetSelector());
                this.modal.dataset.targetSelector = this.getTargetSelector();
                this.elems = {
                    header: this.modal.querySelector('.modal2-header'),
                    footer: this.modal.querySelector('.modal2-footer'),
                    content: this.modal.querySelector('.modal2-content'), // scrollable
                    body: this.modal.querySelector('.modal2-body'),
                    title: this.modal.querySelector('.modal2-header .title')
                };
                this.bottomSheetSwipeClose = null;
            }

            _createClass(ModalItem, [{
                key: "getTargetSelector",
                value: function getTargetSelector() {
                    return '#' + this.params.id;
                }

                /**
                 * @param {boolean|null} showHeader
                 * @param {boolean|null} showFooter
                 */

            }, {
                key: "toggleStickyButtons",
                value: function toggleStickyButtons() {
                    var showHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var showFooter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    if (showHeader !== null && this.$elems.header.length) {
                        this.$elems.header.toggleClass('hidden', !showHeader);
                    }
                    if (showFooter !== null && this.$elems.footer.length) {
                        this.$elems.footer.toggleClass('hidden', !showFooter);
                    }
                }

                /**
                 * @param {string} title
                 */

            }, {
                key: "setTitle",
                value: function setTitle(title) {
                    if (this.elems.header) {
                        var header = this.elems.header;
                        var label = this.params.labelFor ? header.querySelector('.modal2-title__label') : [];
                        if (label.length === 0) {
                            label = header.querySelector('.modal2-title');
                        }
                        label.innerHTML = title;
                    }
                }
            }, {
                key: "show",
                value: function show() {
                    var _this4 = this;

                    document.body.classList.add('modal2-shown', OVERFLOW_HIDDEN_CSS_CLASS);
                    this.modal.classList.add('open');

                    setTimeout(function () {
                        _this4.modal.classList.add(MODAL_IN_CSS_CLASS);
                    }, 10);
                }
            }, {
                key: "loadContent",
                value: function loadContent() {
                    var _this5 = this;

                    // Trigger the beforeShow event
                    var beforeShowEvent = new CustomEvent('beforeShow');
                    this.modal.dispatchEvent(beforeShowEvent);
                    this.initBottomSheetSwipeClose();

                    if (this.params.content.url.length) {
                        // Set loader HTML
                        this.elems.body.innerHTML = this.getLoaderHTML();

                        // Fetch content from the URL
                        fetch(this.params.content.url).then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.text();
                        }).then(function (data) {
                            // Set the body content
                            _this5.elems.body.innerHTML = data;

                            if (_this5.params.onAfterShow) {
                                _this5.params.onAfterShow(_this5.modal);
                            }

                            // Optionally style here

                            // Trigger the afterShow event
                            var afterShowEvent = new CustomEvent('afterShow');
                            _this5.modal.dispatchEvent(afterShowEvent);
                        }).catch(function (error) {
                            _this5.showError({
                                header: _this5.elems.header,
                                content: _this5.elems.body,
                                text: error.message // Use error message
                            });
                        });
                    } else {
                        if (this.content instanceof HTMLElement) {
                            this.elems.body.innerHTML = ''; // Очистим содержимое
                            this.elems.body.appendChild(this.content); // Вставляем DOM-элемент
                        } else if (typeof this.content === 'string') {
                            this.elems.body.innerHTML = this.content;
                        }
                        if (this.params.onAfterShow) {
                            this.params.onAfterShow(this.modal);
                        }
                        // Trigger the afterShow event
                        var afterShowEvent = new CustomEvent('afterShow');
                        this.modal.dispatchEvent(afterShowEvent);
                    }

                    return true;
                }
            }, {
                key: "getLoaderHTML",
                value: function getLoaderHTML() {
                    return '<div class="loading-container loading-container--' + this.params.type + '">' + window.app.loading.circle + '</div>';
                }
            }, {
                key: "showError",
                value: function showError(params) {
                    var $content = params.content;
                    var text = params.text || 'Попробуйте позднее';

                    $content.html('<div class="site-error side-indent text-center">' + '<h2 class="site-header fw-b">Ошибка</h2>' + '<div class="site-error-description">' + text + '</div>' + '</div>');
                }
            }, {
                key: "hide",
                value: function hide() {
                    var _this6 = this;

                    var body = document.body;
                    var preserveSwipeStyles = this.modal.dataset.swipeClosing === '1';

                    if (this.bottomSheetSwipeClose) {
                        this.bottomSheetSwipeClose.destroy({ preserveStyles: preserveSwipeStyles });
                        this.bottomSheetSwipeClose = null;
                    }

                    // Hide started
                    var beforeHideEvent = new CustomEvent('beforeHide');
                    this.modal.dispatchEvent(beforeHideEvent);

                    if (typeof this.params.onBeforeClose === 'function') {
                        this.params.onBeforeClose(this.modal);
                    }

                    this.modal.classList.remove(MODAL_IN_CSS_CLASS);
                    setTimeout(function () {
                        _this6.modal.classList.remove('open');
                        var openedPopups = document.querySelectorAll('.modal2.open');

                        if (!openedPopups.length) {
                            body.classList.remove('modal2-shown', OVERFLOW_HIDDEN_CSS_CLASS);
                        }

                        // hidden. Call after restoring scroll on body
                        var afterHideEvent = new CustomEvent('afterHide');
                        _this6.modal.dispatchEvent(afterHideEvent);

                        if (_this6.params.content.htmlDetachSelectorId.length) {
                            var contentToDetach = document.getElementById(_this6.params.content.htmlDetachSelectorId);
                            if (contentToDetach) {
                                _this6.contentDetachedParent.innerHTML = ''; // Clear the content first
                                _this6.contentDetachedParent.appendChild(contentToDetach); // Append detached content
                            }
                        }

                        // Removal
                        if (typeof _this6.params.onBeforeRemove === 'function') {
                            _this6.params.onBeforeRemove(_this6.modal);
                        }
                        delete _this6.modal.dataset.swipeClosing;
                        _this6.modal.remove();
                    }, this.params.animationDuration);
                }
            }, {
                key: "initBottomSheetSwipeClose",
                value: function initBottomSheetSwipeClose() {
                    var _this7 = this;

                    if (this.bottomSheetSwipeClose || this.params.type !== 'bottom') {
                        return;
                    }

                    this.bottomSheetSwipeClose = new BottomSheetSwipeClose(this.modal, this.elems, function () {
                        if (window.modal && typeof window.modal.close === 'function') {
                            window.modal.close(_this7.getTargetSelector());
                        }
                    });
                    this.bottomSheetSwipeClose.init();
                }

                // Корректный селектор

            }, {
                key: "isTargetValid",
                value: function isTargetValid() {
                    return this.modal && this.modal.classList.contains('modal2');
                }
            }]);

            return ModalItem;
        }();

        module.exports = {
            ModalItem: ModalItem,
            itemConstants: {
                IN_CSS_CLASS: MODAL_IN_CSS_CLASS
            },
            events: events
        };
    }, { "./BottomSheetSwipeClose": 1 }], 3: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var _require = require('./ModalItem'),
            ModalItem = _require.ModalItem,
            itemConstants = _require.itemConstants;

        var itemRender = require('./options/modal-item-render');
        var zIndex = 1000;

        var goBackDebugTimer = 0;

        function dispatchDebugEvent(message) {
            if (window.app.debug) {
                var event = new CustomEvent('modal.debugAlert', {
                    detail: {
                        message: message
                    }
                });
                window.dispatchEvent(event);
            }
        }

        var ModalManager = function () {
            function ModalManager() {
                _classCallCheck(this, ModalManager);

                if (window.modal) {
                    throw new Error('only one instance of ModalManager available');
                }

                /**
                 * @type {number}
                 */
                this.loadingTimestamp = new Date().getTime();

                /**
                 * Поддерживаем ли работу с history API
                 * @type {boolean}
                 */
                this.isHistorySupported = typeof window.history !== 'undefined';

                /**
                 * Когда идет одновременно закрытие history.go(-1) и открытие history.pushState({...})
                 * Блочим открытие до момента, пока не закончится закрытие
                 * @type {number}
                 */
                this.historyPushLockTimer = 0;

                /**
                 * Если пытались что-то открыть в момент, пока открытие было заблочено - откладываем
                 * @type {Array}
                 */
                this.delayedOpenExecution = [];

                /**
                 * z-index модалки
                 * @type {number}
                 */
                this.zIndex = 1000;

                /**
                 * кол-во модалок, открытых на текущий момент
                 * @type {number}
                 */
                this.visibleCount = 0;

                /**
                 * Кол-во модалок, открытых в пределах визита (1 страницы)
                 * ++ при открытии каждой новой модалки
                 * По совместитульству уникальный идетфикатор модалки
                 * @type {number}
                 */
                this.shownCount = 0;

                /**
                 * @type {{}}
                 */
                this.openedItemsByIndex = {};

                /**
                 * Отслеживаем только после загрузки страницы
                 * По history.state нельзя ориентироваться. На момент собыния popstate уже новое состояние
                 * @type {null|any}
                 */
                this.currentHistoryState = null;

                /**
                 * От срабатывания несколько раз .go(-1)
                 * @type {{}}
                 */
                this.popupCloseLocked = {};

                /**
                 * @type {ModalItem}
                 */
                this.closeTargetItem = null;

                this.attachHandlers();
            }

            /**
             * @param {HtModalOptions} options
             * @param {boolean} ignoreLock
             * @return {boolean}
             */


            _createClass(ModalManager, [{
                key: "open",
                value: function open(options) {
                    var _this8 = this;

                    var ignoreLock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    if (!options.validate()) {
                        return false;
                    }
                    if (this.isHistorySupported) {
                        if (this.historyPushLockTimer && !ignoreLock) {
                            // Откладываем выполнение
                            this.delayedOpenExecution.push(function () {
                                _this8.open(options, true);
                            });

                            console.info('modal open postponed dew to history API conflict');
                            return false;
                        }
                    }

                    // render modal
                    document.body.appendChild(itemRender(options, zIndex++));

                    var modalItem = new ModalItem(options);
                    if (!modalItem.isTargetValid()) {
                        console.error('Something went wrong. Can`t open modal');
                        return false;
                    }

                    // Анимация показа
                    modalItem.show();
                    // Если модалка не показана
                    if (!this._isOpenedNow(modalItem)) {
                        this.visibleCount++;
                        this.shownCount++;

                        this.openedItemsByIndex[this.shownCount] = modalItem;
                        modalItem.modal.dataset.index = this.shownCount;

                        if (this.isHistorySupported) {
                            // Была закрыта. Показываем
                            this._unlockClose(modalItem.getTargetSelector());
                            history.pushState({
                                type: 'modal',
                                index: this.shownCount,
                                sessionTimestamp: this.loadingTimestamp
                            }, document.title);
                        }
                    } else {
                        console.warn('requested modal is already opened');
                        // Закрываем все что открыто после,
                        // Чтобы вернуть history.state к состоянию текущей модалки
                        // TODO:
                    }
                    modalItem.loadContent();

                    return true;
                }

                /**
                 * Закрытие модалки с кнопки в интерфейсе
                 * @param self
                 * @param {*} popupSelector - Не используется при включенной истории
                 */

            }, {
                key: "close",
                value: function close(self, popupSelector) {
                    var popup = null;
                    if (typeof popupSelector !== 'undefined' && popupSelector !== null) {
                        popup = document.querySelector(popupSelector);
                    } else {
                        popup = self.closest('.modal2');
                    }

                    popupSelector = popup.dataset.targetSelector; // Accessing the data attribute
                    var targetModalItem = this._getOpenedModalItemByElement(popup);

                    if (this.isHistorySupported) {
                        if (this.haveOpened()) {
                            var currentState = this._parseCurrentState();
                            var closeTargetSelector = currentState.targetModalItem.getTargetSelector();
                            if (!targetModalItem) {
                                console.warn('target modal "%s" is not opened', popupSelector);
                                console.warn('last opened now is "%s"', closeTargetSelector);
                            } else {
                                if (closeTargetSelector !== targetModalItem.getTargetSelector()) {
                                    console.warn('target modal "%s" is opened (not last opened)', popupSelector);
                                    console.warn('last opened now is "%s"', closeTargetSelector);
                                }
                            }
                            if (!popup.classList.contains(itemConstants.IN_CSS_CLASS)) {
                                // If the modal where the button was clicked or passed as a selector is closed
                                console.warn('blocked close for "%s"', closeTargetSelector);
                                return;
                            }
                        }
                        // Close the last opened modal
                        this._closeLast();
                    } else {
                        this.closeTargetItem = targetModalItem;
                        this._runClose();
                    }

                    return true;
                }
            }, {
                key: "_closeLast",
                value: function _closeLast() {
                    if (!this.isHistorySupported) {
                        return false;
                    }
                    var self = this;
                    var currentState = this._parseCurrentState();
                    if (currentState.targetModalItem) {
                        // От двойных срабатываний .go(-1) при закрытии одной и той же модалки
                        // При следующем открытии снимаем флаг
                        if (!this._isCloseLocked(currentState.targetModalItem.getTargetSelector())) {
                            this._lockClose(currentState.targetModalItem.getTargetSelector());

                            if (this.historyPushLockTimer) {
                                clearTimeout(this.historyPushLockTimer);
                                this.historyPushLockTimer = 0;
                            }

                            this.historyPushLockTimer = setTimeout(function () {
                                self._onAfterHistoryPushUnlock();
                            }, 10);

                            goBackDebugTimer = setTimeout(function () {
                                dispatchDebugEvent('modal popstate event was not fired after 100ms from go(-1)');
                            }, 100);

                            // Закрытие в popstate
                            // Закрывает модалку из this._parseCurrentState();
                            history.go(-1);

                            return true;
                        } else if (window.app.debug) {
                            dispatchDebugEvent('modal close locked. consider check onpopstate event listener');
                        }
                    }

                    return false;
                }
            }, {
                key: "_runClose",
                value: function _runClose() {
                    var modalItem = this.closeTargetItem;
                    if (!modalItem || !this._isOpenedNow(modalItem)) {
                        return false;
                    }
                    var openedModalIndex = modalItem.modal.dataset.index; // Accessing the data attribute
                    delete this.openedItemsByIndex[openedModalIndex];

                    if (this.visibleCount) {
                        this.visibleCount--;
                    }

                    if (this.visibleCount === 0) {
                        this.openedItemsByIndex = {};
                    }

                    // Set default
                    this.closeTargetItem = null;

                    modalItem.hide(); // Assuming hide() is a method on modalItem
                }
            }, {
                key: "haveOpened",
                value: function haveOpened() {
                    return this.visibleCount > 0;
                }
            }, {
                key: "attachHandlers",
                value: function attachHandlers() {
                    var _this9 = this;

                    if (this.isHistorySupported) {
                        this._attachHistoryStateHandlers();
                    }
                    document.addEventListener('DOMContentLoaded', function () {
                        _this9._attachDOMHandlers();
                    });
                }
            }, {
                key: "_attachDOMHandlers",
                value: function _attachDOMHandlers() {
                    var _this10 = this;

                    var self = this;
                    document.body.addEventListener('click', function (e) {
                        var closeBtn = e.target.closest('.modal2-close');
                        var overlay = e.target.closest('.modal2-overlay');

                        if (closeBtn || overlay) {
                            _this10.close(closeBtn || overlay);
                        }
                    });
                }
            }, {
                key: "_attachHistoryStateHandlers",
                value: function _attachHistoryStateHandlers() {
                    if (!this.isHistorySupported) {
                        return false;
                    }

                    var self = this;
                    (function (history) {
                        var pushState = history.pushState;
                        history.pushState = function (state) {
                            self._onPushState({
                                state: state
                            });
                            return pushState.apply(history, arguments);
                        };
                    })(window.history);

                    window.addEventListener('popstate', function (e) {
                        self._onPopState(e);
                    }, false);

                    return true;
                }
            }, {
                key: "_onPushState",
                value: function _onPushState(e) {
                    this.currentHistoryState = e.state;
                }
            }, {
                key: "_onPopState",
                value: function _onPopState(e) {
                    if (goBackDebugTimer) {
                        clearTimeout(goBackDebugTimer);
                    }
                    // Предыдущее состояние, до popstate
                    var previousState = this._parseCurrentState();
                    // Обновляем текущее состояние истории
                    this.currentHistoryState = e.state;

                    if (this.haveOpened() && previousState.isCurrentSessionState && previousState.targetModalItem) {
                        // Если в предыдущем состоянии была наша модалка - закрываем
                        this.closeTargetItem = previousState.targetModalItem;
                        this._runClose();
                    }
                }

                /**
                 * @return {{isModalState: boolean, isCurrentSessionState: boolean, targetModalItem: ModalItem}}
                 * @private
                 */

            }, {
                key: "_parseCurrentState",
                value: function _parseCurrentState() {
                    var state = this.currentHistoryState;
                    var isModalState = state !== null && (typeof state === "undefined" ? "undefined" : _typeof(state)) === 'object' && state.type === 'modal';
                    var isCurrentSessionState = isModalState && state.sessionTimestamp === this.loadingTimestamp;

                    return {
                        isModalState: isModalState,
                        isCurrentSessionState: isCurrentSessionState,
                        targetModalItem: isCurrentSessionState ? this._getOpenedModalItemByIndex(state.index) : null
                    };
                }

                /**
                 *
                 * @param index
                 * @return {ModalItem|null}
                 * @private
                 */

            }, {
                key: "_getOpenedModalItemByIndex",
                value: function _getOpenedModalItemByIndex(index) {
                    return this.openedItemsByIndex[index] || null;
                }

                /**
                 *
                 * @param $modal
                 * @return {ModalItem|null}
                 * @private
                 */

            }, {
                key: "_getOpenedModalItemByElement",
                value: function _getOpenedModalItemByElement($modal) {
                    var openedModalIndex = $modal && $modal.classList.contains('modal2') ? $modal.dataset.index : null;
                    var modalItem = this._getOpenedModalItemByIndex(openedModalIndex);
                    if (modalItem && this._isOpenedNow(modalItem)) {
                        return modalItem;
                    }

                    return null;
                }

                /**
                 * @param selector
                 * @return {ModalItem|null}
                 */

            }, {
                key: "getOpenedNowModalItemByChild",
                value: function getOpenedNowModalItemByChild(selector) {
                    var child = document.querySelector(selector);
                    if (child) {
                        return this._getOpenedModalItemByElement(child.closest('.modal2'));
                    }
                }
            }, {
                key: "_onAfterHistoryPushUnlock",
                value: function _onAfterHistoryPushUnlock() {
                    var len = this.delayedOpenExecution.length;
                    if (len) {
                        var i = void 0;
                        for (i = 0; i < len; i++) {
                            this.delayedOpenExecution[i]();
                        }
                        this.delayedOpenExecution = [];
                    }
                    this.historyPushLockTimer = 0;
                }

                // Для одной и той же модалки не делать go(-1) несколько раз,
                // пока снова не будет записи в источрии

            }, {
                key: "_lockClose",
                value: function _lockClose(popupSelector) {
                    this.popupCloseLocked[popupSelector] = 1;
                }

                // При новом открытии, вместе с pushState

            }, {
                key: "_unlockClose",
                value: function _unlockClose(popupSelector) {
                    this.popupCloseLocked[popupSelector] = 0;
                }

                // Уже вызвано событие закрытия для этой модалки.
                // Пока не закроется не вызывать history.go(-1) для этой модалки

            }, {
                key: "_isCloseLocked",
                value: function _isCloseLocked(popupSelector) {
                    return this.popupCloseLocked.hasOwnProperty(popupSelector) && this.popupCloseLocked[popupSelector] === 1;
                }
            }, {
                key: "_isOpenedNow",
                value: function _isOpenedNow(modalItem) {
                    var shownIndex = modalItem.modal.dataset.index; // Access data attribute directly
                    // if popup was shown sometime ago OR was shown and closed at least once
                    return shownIndex && this.openedItemsByIndex.hasOwnProperty(shownIndex);
                }
            }]);

            return ModalManager;
        }();

        module.exports = ModalManager;
    }, { "./ModalItem": 2, "./options/modal-item-render": 5 }], 4: [function (require, module, exports) {
        var SIZE_SM = 'sm';
        var THEME_DEFAULT = 'default';
        var THEME_SECONDARY = 'secondary';
        var THEME_TRANSPARENT = 'transparent';
        var THEME_PRIMARY = 'primary';
        var TYPE_FULL = 'full';
        var TYPE_BOTTOM = 'bottom';
        var TYPE_FLOATING = 'floating';

        module.exports = {
            SIZE_SM: SIZE_SM,
            THEME_DEFAULT: THEME_DEFAULT,
            THEME_SECONDARY: THEME_SECONDARY,
            THEME_TRANSPARENT: THEME_TRANSPARENT,
            THEME_PRIMARY: THEME_PRIMARY,
            TYPE_FULL: TYPE_FULL,
            TYPE_BOTTOM: TYPE_BOTTOM,
            TYPE_FLOATING: TYPE_FLOATING
        };
    }, {}], 5: [function (require, module, exports) {
        var _require2 = require('./constant'),
            THEME_TRANSPARENT = _require2.THEME_TRANSPARENT;

        /**
         * @param {HtModalOptions} options
         * @param {number} zIndex
         * @return {HTMLDivElement}
         */


        module.exports = function (options, zIndex) {
            var _popup$classList, _overlay$classList, _contentBody$classLis;

            var popup = document.createElement('div');
            popup.id = options.id;
            var typeClass = options.type ? "modal2--" + options.type : null;
            var parentClasses = typeof options.parentCssClass === 'string' ? options.parentCssClass.split(/\s+/).filter(Boolean) : [];
            (_popup$classList = popup.classList).add.apply(_popup$classList, _toConsumableArray(['modal2', typeClass].concat(_toConsumableArray(parentClasses)).filter(Boolean)));

            var overlay = document.createElement('div');
            overlay.setAttribute('role', 'button');
            (_overlay$classList = overlay.classList).add.apply(_overlay$classList, ['modal2-overlay', 'modal2-overlay--blurred', 'fade-animation']);

            var content = options.content.render();
            if (options.fixContentMaxHeight) {
                content.classList.add('fix-max-height');
            }

            var isContentBg = true;
            if (options.header) {
                if (options.header.isSticky()) {
                    popup.classList.add('fixed-header');
                }
                // header внутри content для sticky
                content.append(options.header.render());
                isContentBg = !options.header.isTransparent();
            }

            var contentBody = document.createElement('div');
            (_contentBody$classLis = contentBody.classList).add.apply(_contentBody$classLis, ['modal2-body']);
            if (options.footer && options.footer.height !== null) {
                contentBody.style.paddingBottom = options.footer.height + 'px';
            }
            if (isContentBg) {
                content.classList.add('theme-' + options.content.theme);
            } else {
                contentBody.classList.add('theme-' + options.content.theme);
                contentBody.classList.add('rounded-top');
                content.classList.add('theme-' + THEME_TRANSPARENT); // overwrite defaults
            }
            content.append(contentBody);

            popup.append(overlay);
            popup.append(content);
            if (options.footer !== null) {
                var footer = options.footer.render();
                footer.style.zIndex = zIndex;
                popup.classList.add('fixed-footer');
                popup.append(footer);
            }
            content.style.zIndex = zIndex;
            popup.style.zIndex = zIndex;

            return popup;
        };
    }, { "./constant": 4 }], 6: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var i18nMessages = {
            labelBackBtn: 'Закрыть',
            labelSelect: 'Выбрать'
        };

        var c = require('./constant');

        /**
         * @property {string} title
         * @property {string|null} titleSize - см. c.SIZE_{TYPE}
         * @property {string|null} titleFor
         * @property {'center'|'left'} titleAlign
         * @property {HTMLElement|string|null} html - custom content
         */

        var HtModalHeader = function () {
            function HtModalHeader(props) {
                _classCallCheck(this, HtModalHeader);

                this.title = props.title;
                this.titleSize = props.titleSize || null;
                this.titleFor = props.titleFor || null;
                this.titleAlign = props.titleAlign || 'center';
                this.html = props.html || null; // custom content
                this.theme = props.theme || c.THEME_DEFAULT;
            }

            _createClass(HtModalHeader, [{
                key: "isTransparent",
                value: function isTransparent() {
                    return this.theme === c.THEME_TRANSPARENT;
                }
            }, {
                key: "isSticky",
                value: function isSticky() {
                    return !this.isTransparent();
                }

                /** @return HTMLDivElement */

            }, {
                key: "render",
                value: function render() {
                    var _header$classList;

                    var header = document.createElement('div');
                    (_header$classList = header.classList).add.apply(_header$classList, ['modal2-header', 'theme-' + this.theme]);

                    if (this.isTransparent()) {
                        header.append(this.renderCloseButton());
                    } else {
                        header.classList.add('modal2-header--rounded');
                        if (this.isSticky()) {
                            header.classList.add('sticky');
                        }
                        header.innerHTML = this.renderTitle();
                        if (this.html !== null) {
                            var customContent = document.createElement('div');
                            customContent.classList.add('modal2-header__content'); // modal-header__content
                            customContent.classList.add('custom-content'); // modal-header__content
                            customContent.innerHTML = this.html;
                            header.append(customContent);
                        }
                    }

                    return header;
                }

                /**
                 * @private
                 * @return {HTMLDivElement}
                 */

            }, {
                key: "renderTitle",
                value: function renderTitle() {
                    var titleContent = void 0;
                    if (this.titleFor) {
                        titleContent = "<label class=\"modal2-title__label\" for=\"" + this.titleFor + "\">" + this.title + "</label>";
                    } else {
                        titleContent = this.title;
                    }

                    var classList = ['modal2-title', 'align-' + this.titleAlign]; // header-title => modal-title
                    if (this.titleSize !== null) {
                        classList.push('modal2-title--' + this.titleSize);
                    }
                    return '<div class="' + classList.join(' ') + ' text-ellipsis">' + titleContent + '</div>' + '<div class="aside-right">' + '<button type="button"' + ' class="modal2-header__close-circle modal2-close"' + ' aria-label="' + i18nMessages.labelBackBtn + '"></button>' + '</div>';
                }
            }, {
                key: "renderCloseButton",
                value: function renderCloseButton() {
                    var _button$classList;

                    var button = document.createElement('button');
                    button.type = 'button';
                    (_button$classList = button.classList).add.apply(_button$classList, ['modal2-header__close-cross', 'modal2-close']);
                    button.setAttribute('aria-label', i18nMessages.labelBackBtn);
                    return button;
                }
            }]);

            return HtModalHeader;
        }();

        /**
         * Одновременно можно использовать только 1 из доступных способов:
         * @property {HTMLElement|string} html - Значение будет выведено в качестве контента
         * @property {string} htmlDetachSelectorId - Элемент со страницы будет выведен в качестве контента
         * @property {string} url - Контент будет загружен отложено
         * @property {string} theme - Тема модалки
         */


        var HtModalContent = function () {
            function HtModalContent(props) {
                _classCallCheck(this, HtModalContent);

                this.html = props.html || '';
                this.htmlDetachSelectorId = props.htmlDetachSelectorId || '';
                this.url = props.url || '';
                this.theme = props.theme || c.THEME_DEFAULT;
            }

            /** @return {HTMLDivElement} */


            _createClass(HtModalContent, [{
                key: "render",
                value: function render() {
                    var _content$classList;

                    var content = document.createElement('div');
                    (_content$classList = content.classList).add.apply(_content$classList, ['modal2-content']);
                    return content;
                }
            }]);

            return HtModalContent;
        }();

        /**
         * @property {string} theme
         * @property {string} buttonLabel
         * @property {string} buttonCssClass
         * @property {number|null} height
         */


        var HtModalFooter = function () {
            function HtModalFooter(props) {
                _classCallCheck(this, HtModalFooter);

                this.theme = props.theme || c.THEME_DEFAULT;
                this.buttonLabel = props.buttonLabel || i18nMessages.labelSelect;
                this.buttonCssClass = props.buttonCssClass || '';
                this.height = props.height || null;
            }

            /** @return {HTMLDivElement} */


            _createClass(HtModalFooter, [{
                key: "render",
                value: function render() {
                    var _footer$classList;

                    var footer = document.createElement('div');
                    (_footer$classList = footer.classList).add.apply(_footer$classList, ['modal2-footer', 'fade-animation', 'theme-' + this.theme]);
                    footer.append(this.renderButton());

                    return footer;
                }

                /**
                 * @private
                 * @return {HTMLButtonElement}
                 */

            }, {
                key: "renderButton",
                value: function renderButton() {
                    var _button$classList2;

                    var button = document.createElement('button');
                    button.type = 'button';
                    var classList = 'btn btn-blue modal2-close';
                    if (this.buttonCssClass !== '') {
                        classList += ' ' + this.buttonCssClass;
                    }
                    classList = classList.trim().split(' ');
                    (_button$classList2 = button.classList).add.apply(_button$classList2, _toConsumableArray(classList));
                    button.innerHTML = this.buttonLabel;

                    return button;
                }
            }, {
                key: "getCssHeight",
                value: function getCssHeight() {
                    if (this.height === null) {
                        return null;
                    }
                    return this.height + 'px';
                }
            }]);

            return HtModalFooter;
        }();

        /**
         * @property {string} id - Selecor ID модалки.
         *  Для обратной совместимости с формой поиска.
         *  Нежелательно передавать снаружи
         * @property {HtModalContent} content - настройки отображения контента
         * @property {HtModalHeader|null} header - настройки отображения шапки
         * @property {HtModalFooter|null} footer - настройки отображения футера
         * @property {Function|null} onAfterShow - колбек перед началом показа
         * @property {Function|null} onBeforeClose - колбек перед закрытием
         * @property {Function|null} onBeforeRemove - колбек перед удалением из DOM
         */


        var HtModalOptions = function () {
            function HtModalOptions(props) {
                _classCallCheck(this, HtModalOptions);

                // required
                this.header = props.header;
                this.content = props.content;
                this.animationDuration = props.animationDuration || 400;
                // optional
                this.id = props.id || this.randomId();
                this.type = props.type || c.TYPE_BOTTOM;
                this.parentCssClass = props.parentCssClass || '';
                this.fixContentMaxHeight = props.fixContentMaxHeight || false;
                this.footer = props.footer || null;
                this.onAfterShow = typeof props.onAfterShow === 'function' ? props.onAfterShow : null;
                this.onBeforeClose = typeof props.onBeforeClose === 'function' ? props.onBeforeClose : null;
                this.onBeforeRemove = typeof props.onBeforeRemove === 'function' ? props.onBeforeRemove : null;
            }

            _createClass(HtModalOptions, [{
                key: "randomId",
                value: function randomId() {
                    return 'modal2--id-' + new Date().getTime() + '-' + Math.ceil(Math.random() * 1000);
                }
            }, {
                key: "validate",
                value: function validate() {
                    return this.content.html || this.content.htmlDetachSelectorId || this.content.url;
                }
            }]);

            return HtModalOptions;
        }();

        /**
         * Построение конфигурации из объекта
         * @param optionsConfig
         * @return {HtModalOptions}
         */


        function buildHtModalOptions(optionsConfig) {
            if (optionsConfig instanceof HtModalOptions) {
                return optionsConfig;
            }

            var footer = null;
            if (optionsConfig.footer) {
                footer = new HtModalFooter(optionsConfig.footer);
            }
            var header = null;
            if (optionsConfig.header) {
                header = new HtModalHeader(optionsConfig.header);
            }

            return new HtModalOptions({
                id: optionsConfig.id,
                type: optionsConfig.type,
                parentCssClass: optionsConfig.parentCssClass,
                animationDuration: optionsConfig.animationDuration || null,
                // sections
                header: header,
                footer: footer,
                content: new HtModalContent(optionsConfig.content),
                // settings
                fixContentMaxHeight: optionsConfig.fixContentMaxHeight || null,
                // callbacks
                onAfterShow: optionsConfig.onAfterShow || null,
                onBeforeClose: optionsConfig.onBeforeClose || null,
                onBeforeRemove: optionsConfig.onBeforeRemove || null
            });
        }

        module.exports = {
            build: buildHtModalOptions,
            themes: {
                DEFAULT: c.THEME_DEFAULT,
                SECONDARY: c.THEME_SECONDARY,
                TRANSPARENT: c.THEME_TRANSPARENT,
                PRIMARY: c.THEME_PRIMARY
            },
            sizes: {
                SM: c.SIZE_SM
            },
            types: {
                FULL: c.TYPE_FULL,
                BOTTOM: c.TYPE_BOTTOM,
                FLOATING: c.TYPE_FLOATING
            }
        };
    }, { "./constant": 4 }], 7: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var ModalManager = require('./helpers/ModalManager');
        var options = require('./helpers/options/options');

        // modal
        var manager = new ModalManager();
        var modal = {
            /**
             * Показать модалку
             * Принимает подобный классу объект.
             * Объект указан как тип для подсветки
             * @param {HtModalOptions|{}} config
             */
            open: function open(config) {
                manager.open(options.build(config));
            },
            /**
             * @param {jQuery} $child
             * @param {Function|null} onAfterHide - пробрость колбек после закрытия
             *      e.g. Закрыть модалку опционально, и показать еще одну. Порядок действий важен
             * @return {boolean}
             */
            closeParent: function closeParent($child) {
                var onAfterHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                var item = manager.getOpenedNowModalItemByChild($child);
                if (item) {
                    if (onAfterHide !== null) {
                        item.$modal.one('hidden.modal2', function () {
                            onAfterHide();
                        });
                    }
                    manager.close(null, item.getTargetSelector());
                    return true;
                }
                return false;
            },
            /**
             * Находится ли элемент внутри открытой модалки
             * @param {jQuery} $child
             * @return {boolean}
             */
            isChild: function isChild($child) {
                return !!manager.getOpenedNowModalItemByChild($child);
            },
            /**
             * Must be called before openPopup
             * (in case both called at the same time "close_popup(selector)" and "open_popup")
             * @param {string} targetSelector - ignored, everytime will be closed top modal
             */
            close: function close(targetSelector) {
                manager.close(null, targetSelector);
            },
            /**
             * Показать/скрыть прилипающие кнопки
             * @param {jQuery} $child
             * @param {boolean|null} showHeader
             * @param {boolean|null} showFooter
             */
            toggleParentStickyButtons: function toggleParentStickyButtons($child, _ref2) {
                var _ref2$showHeader = _ref2.showHeader,
                    showHeader = _ref2$showHeader === undefined ? null : _ref2$showHeader,
                    _ref2$showFooter = _ref2.showFooter,
                    showFooter = _ref2$showFooter === undefined ? null : _ref2$showFooter;

                var item = manager.getOpenedNowModalItemByChild($child);
                if (item) {
                    item.toggleStickyButtons(showHeader, showFooter);
                }
            },
            /**
             * Изменить title в уже открытой модалке
             * @param {string} selector
             * @param {string} title
             */
            setTitle: function setTitle(selector, title) {
                var item = manager.getOpenedNowModalItemByChild(selector);
                if (item) {
                    item.setTitle(title);
                }
            },

            types: options.types,
            themes: options.themes,
            sizes: options.sizes
        };

        window.modal = modal;
    }, { "./helpers/ModalManager": 3, "./helpers/options/options": 6 }] }, {}, [7]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var BottomSheetSwipeClose = function () {
            function BottomSheetSwipeClose(modal, elems) {
                var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                _classCallCheck(this, BottomSheetSwipeClose);

                this.modal = modal;
                this.elems = elems || {};
                this.onClose = typeof onClose === 'function' ? onClose : null;

                this.startY = 0;
                this.startX = 0;
                this.startScrollTop = 0;
                this.lastY = 0;
                this.lastMoveAt = 0;
                this.prevY = 0;
                this.prevMoveAt = 0;
                this.currentOffset = 0;

                this.isPotentialDrag = false;
                this.isDragging = false;
                this.isClosing = false;
                this.resetAnimationTimer = null;

                this.onTouchStart = this.handleTouchStart.bind(this);
                this.onTouchMove = this.handleTouchMove.bind(this);
                this.onTouchEnd = this.handleTouchEnd.bind(this);
                this.onTouchCancel = this.handleTouchCancel.bind(this);
            }

            _createClass(BottomSheetSwipeClose, [{
                key: "init",
                value: function init() {
                    if (!this.isEnabled() || !this.modal) {
                        return;
                    }

                    this.modal.addEventListener('touchstart', this.onTouchStart, { passive: true });
                    this.modal.addEventListener('touchmove', this.onTouchMove, { passive: false });
                    this.modal.addEventListener('touchend', this.onTouchEnd, { passive: true });
                    this.modal.addEventListener('touchcancel', this.onTouchCancel, { passive: true });
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                        _ref3$preserveStyles = _ref3.preserveStyles,
                        preserveStyles = _ref3$preserveStyles === undefined ? false : _ref3$preserveStyles;

                    if (!this.modal) {
                        return;
                    }

                    this.modal.removeEventListener('touchstart', this.onTouchStart);
                    this.modal.removeEventListener('touchmove', this.onTouchMove);
                    this.modal.removeEventListener('touchend', this.onTouchEnd);
                    this.modal.removeEventListener('touchcancel', this.onTouchCancel);

                    if (this.resetAnimationTimer) {
                        clearTimeout(this.resetAnimationTimer);
                        this.resetAnimationTimer = null;
                    }

                    this.resetState();
                    if (!preserveStyles) {
                        this.resetStyles();
                    }
                }
            }, {
                key: "isEnabled",
                value: function isEnabled() {
                    return !!(this.modal && this.modal.classList && this.modal.classList.contains('modal2--bottom') && this.elems.content);
                }
            }, {
                key: "handleTouchStart",
                value: function handleTouchStart(event) {
                    if (!this.isEnabled() || this.isClosing || !event.touches || event.touches.length !== 1) {
                        return;
                    }

                    var touch = event.touches[0];
                    var target = event.target instanceof Element ? event.target : null;
                    if (!target || !this.isAllowedStartTarget(target, touch.clientY)) {
                        return;
                    }

                    var scrollTop = this.getScrollTop();
                    if (scrollTop > 0) {
                        return;
                    }

                    this.startY = touch.clientY;
                    this.startX = touch.clientX;
                    this.lastY = touch.clientY;
                    this.lastMoveAt = Date.now();
                    this.prevY = touch.clientY;
                    this.prevMoveAt = this.lastMoveAt;
                    this.startScrollTop = scrollTop;
                    this.currentOffset = 0;
                    this.isPotentialDrag = true;
                    this.isDragging = false;
                }
            }, {
                key: "handleTouchMove",
                value: function handleTouchMove(event) {
                    if (!this.isPotentialDrag && !this.isDragging || !event.touches || event.touches.length !== 1) {
                        return;
                    }

                    var touch = event.touches[0];
                    var deltaY = touch.clientY - this.startY;
                    var deltaX = touch.clientX - this.startX;

                    this.prevY = this.lastY;
                    this.prevMoveAt = this.lastMoveAt;
                    this.lastY = touch.clientY;
                    this.lastMoveAt = Date.now();

                    if (!this.isDragging) {
                        if (Math.abs(deltaY) < BottomSheetSwipeClose.DRAG_START_PX) {
                            return;
                        }

                        if (Math.abs(deltaX) > Math.abs(deltaY) || deltaY <= 0 || this.startScrollTop > 0 || this.getScrollTop() > 0) {
                            this.resetState();
                            return;
                        }

                        this.beginDrag();
                    }

                    event.preventDefault();

                    var offset = Math.max(0, deltaY);
                    this.currentOffset = offset;
                    this.render(offset);
                }
            }, {
                key: "handleTouchEnd",
                value: function handleTouchEnd() {
                    if (!this.isDragging) {
                        this.resetState();
                        return;
                    }

                    var dragDuration = Math.max(1, this.lastMoveAt - this.prevMoveAt);
                    var velocity = Math.max(0, this.lastY - this.prevY) / dragDuration;
                    var shouldClose = this.currentOffset >= this.getCloseDistance() || velocity >= BottomSheetSwipeClose.CLOSE_VELOCITY_PX_PER_MS;

                    if (shouldClose) {
                        this.closeWithAnimation();
                        return;
                    }

                    this.rollback();
                }
            }, {
                key: "handleTouchCancel",
                value: function handleTouchCancel() {
                    if (this.isDragging) {
                        this.rollback();
                        return;
                    }

                    this.resetState();
                }
            }, {
                key: "isAllowedStartTarget",
                value: function isAllowedStartTarget(target, clientY) {
                    if (this.elems.header && this.elems.header.contains(target)) {
                        return true;
                    }

                    if (!this.elems.content || !this.elems.content.contains(target)) {
                        return false;
                    }

                    var contentRect = this.elems.content.getBoundingClientRect();
                    return clientY <= contentRect.top + BottomSheetSwipeClose.START_ZONE_PX;
                }
            }, {
                key: "beginDrag",
                value: function beginDrag() {
                    this.isDragging = true;
                    this.modal.classList.add('modal2--swipe-dragging');

                    if (this.elems.content) {
                        this.elems.content.style.transition = 'none';
                        this.elems.content.style.willChange = 'transform';
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = 'none';
                        this.elems.footer.style.willChange = 'transform';
                    }
                    if (this.getOverlay()) {
                        this.getOverlay().style.transition = 'none';
                        this.getOverlay().style.willChange = 'opacity';
                    }
                }
            }, {
                key: "render",
                value: function render(offset) {
                    if (this.elems.content) {
                        this.elems.content.style.transform = "translateY(" + offset + "px)";
                    }

                    if (this.elems.footer) {
                        this.elems.footer.style.transform = "translateY(" + offset + "px)";
                    }

                    var overlay = this.getOverlay();
                    if (overlay) {
                        var opacity = Math.max(0, 1 - offset / Math.max(this.getContentHeight(), 1) * 1.6);
                        overlay.style.opacity = "" + opacity;
                    }
                }
            }, {
                key: "rollback",
                value: function rollback() {
                    var _this11 = this;

                    this.resetState();
                    this.animateTo(0, function () {
                        _this11.modal.classList.remove('modal2--swipe-dragging');
                        _this11.resetStyles();
                    });
                }
            }, {
                key: "closeWithAnimation",
                value: function closeWithAnimation() {
                    var _this12 = this;

                    if (this.isClosing) {
                        return;
                    }

                    this.isClosing = true;
                    this.resetState();
                    this.modal.dataset.swipeClosing = '1';

                    this.animateTo(window.innerHeight, function () {
                        if (_this12.onClose) {
                            _this12.onClose();
                        }
                    }, true);
                }
            }, {
                key: "animateTo",
                value: function animateTo(offset, onComplete) {
                    var _this13 = this;

                    var hideOverlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                    var transition = "transform " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease, opacity " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease";
                    var overlay = this.getOverlay();

                    if (this.elems.content) {
                        this.elems.content.style.transition = transition;
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = transition;
                    }
                    if (overlay) {
                        overlay.style.transition = "opacity " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease";
                    }

                    requestAnimationFrame(function () {
                        if (_this13.elems.content) {
                            _this13.elems.content.style.transform = offset > 0 ? "translateY(" + offset + "px)" : '';
                        }
                        if (_this13.elems.footer) {
                            _this13.elems.footer.style.transform = offset > 0 ? "translateY(" + offset + "px)" : '';
                        }
                        if (overlay) {
                            overlay.style.opacity = hideOverlay ? '0' : '';
                        }
                    });

                    this.resetAnimationTimer = setTimeout(function () {
                        _this13.resetAnimationTimer = null;
                        if (typeof onComplete === 'function') {
                            onComplete();
                        }
                    }, BottomSheetSwipeClose.CLOSE_ANIMATION_MS);
                }
            }, {
                key: "getCloseDistance",
                value: function getCloseDistance() {
                    return Math.min(140, Math.max(80, Math.round(this.getContentHeight() * 0.22)));
                }
            }, {
                key: "getContentHeight",
                value: function getContentHeight() {
                    return this.elems.content ? this.elems.content.getBoundingClientRect().height : window.innerHeight;
                }
            }, {
                key: "getOverlay",
                value: function getOverlay() {
                    return this.modal ? this.modal.querySelector('.modal2-overlay') : null;
                }
            }, {
                key: "getScrollTop",
                value: function getScrollTop() {
                    return this.elems.content ? this.elems.content.scrollTop : 0;
                }
            }, {
                key: "resetState",
                value: function resetState() {
                    this.isPotentialDrag = false;
                    this.isDragging = false;
                    this.currentOffset = 0;
                }
            }, {
                key: "resetStyles",
                value: function resetStyles() {
                    var overlay = this.getOverlay();

                    if (this.elems.content) {
                        this.elems.content.style.transition = '';
                        this.elems.content.style.transform = '';
                        this.elems.content.style.willChange = '';
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = '';
                        this.elems.footer.style.transform = '';
                        this.elems.footer.style.willChange = '';
                    }
                    if (overlay) {
                        overlay.style.transition = '';
                        overlay.style.opacity = '';
                        overlay.style.willChange = '';
                    }

                    if (this.modal) {
                        this.modal.classList.remove('modal2--swipe-dragging');
                    }
                }
            }], [{
                key: "START_ZONE_PX",
                get: function get() {
                    return 50;
                }
            }, {
                key: "DRAG_START_PX",
                get: function get() {
                    return 6;
                }
            }, {
                key: "CLOSE_VELOCITY_PX_PER_MS",
                get: function get() {
                    return 0.45;
                }
            }, {
                key: "CLOSE_ANIMATION_MS",
                get: function get() {
                    return 220;
                }
            }]);

            return BottomSheetSwipeClose;
        }();

        module.exports = BottomSheetSwipeClose;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var BottomSheetSwipeClose = function () {
            function BottomSheetSwipeClose(modal, elems) {
                var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                _classCallCheck(this, BottomSheetSwipeClose);

                this.modal = modal;
                this.elems = elems || {};
                this.onClose = typeof onClose === 'function' ? onClose : null;

                this.startY = 0;
                this.startX = 0;
                this.startScrollTop = 0;
                this.lastY = 0;
                this.lastMoveAt = 0;
                this.prevY = 0;
                this.prevMoveAt = 0;
                this.currentOffset = 0;

                this.isPotentialDrag = false;
                this.isDragging = false;
                this.isClosing = false;
                this.resetAnimationTimer = null;

                this.onTouchStart = this.handleTouchStart.bind(this);
                this.onTouchMove = this.handleTouchMove.bind(this);
                this.onTouchEnd = this.handleTouchEnd.bind(this);
                this.onTouchCancel = this.handleTouchCancel.bind(this);
            }

            _createClass(BottomSheetSwipeClose, [{
                key: "init",
                value: function init() {
                    if (!this.isEnabled() || !this.modal) {
                        return;
                    }

                    this.modal.addEventListener('touchstart', this.onTouchStart, { passive: true });
                    this.modal.addEventListener('touchmove', this.onTouchMove, { passive: false });
                    this.modal.addEventListener('touchend', this.onTouchEnd, { passive: true });
                    this.modal.addEventListener('touchcancel', this.onTouchCancel, { passive: true });
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                        _ref4$preserveStyles = _ref4.preserveStyles,
                        preserveStyles = _ref4$preserveStyles === undefined ? false : _ref4$preserveStyles;

                    if (!this.modal) {
                        return;
                    }

                    this.modal.removeEventListener('touchstart', this.onTouchStart);
                    this.modal.removeEventListener('touchmove', this.onTouchMove);
                    this.modal.removeEventListener('touchend', this.onTouchEnd);
                    this.modal.removeEventListener('touchcancel', this.onTouchCancel);

                    if (this.resetAnimationTimer) {
                        clearTimeout(this.resetAnimationTimer);
                        this.resetAnimationTimer = null;
                    }

                    this.resetState();
                    if (!preserveStyles) {
                        this.resetStyles();
                    }
                }
            }, {
                key: "isEnabled",
                value: function isEnabled() {
                    return !!(this.modal && this.modal.classList && this.modal.classList.contains('modal2--bottom') && this.elems.content);
                }
            }, {
                key: "handleTouchStart",
                value: function handleTouchStart(event) {
                    if (!this.isEnabled() || this.isClosing || !event.touches || event.touches.length !== 1) {
                        return;
                    }

                    var touch = event.touches[0];
                    var target = event.target instanceof Element ? event.target : null;
                    if (!target || !this.isAllowedStartTarget(target, touch.clientY)) {
                        return;
                    }

                    var scrollTop = this.getScrollTop();
                    if (scrollTop > 0) {
                        return;
                    }

                    this.startY = touch.clientY;
                    this.startX = touch.clientX;
                    this.lastY = touch.clientY;
                    this.lastMoveAt = Date.now();
                    this.prevY = touch.clientY;
                    this.prevMoveAt = this.lastMoveAt;
                    this.startScrollTop = scrollTop;
                    this.currentOffset = 0;
                    this.isPotentialDrag = true;
                    this.isDragging = false;
                }
            }, {
                key: "handleTouchMove",
                value: function handleTouchMove(event) {
                    if (!this.isPotentialDrag && !this.isDragging || !event.touches || event.touches.length !== 1) {
                        return;
                    }

                    var touch = event.touches[0];
                    var deltaY = touch.clientY - this.startY;
                    var deltaX = touch.clientX - this.startX;

                    this.prevY = this.lastY;
                    this.prevMoveAt = this.lastMoveAt;
                    this.lastY = touch.clientY;
                    this.lastMoveAt = Date.now();

                    if (!this.isDragging) {
                        if (Math.abs(deltaY) < BottomSheetSwipeClose.DRAG_START_PX) {
                            return;
                        }

                        if (Math.abs(deltaX) > Math.abs(deltaY) || deltaY <= 0 || this.startScrollTop > 0 || this.getScrollTop() > 0) {
                            this.resetState();
                            return;
                        }

                        this.beginDrag();
                    }

                    event.preventDefault();

                    var offset = Math.max(0, deltaY);
                    this.currentOffset = offset;
                    this.render(offset);
                }
            }, {
                key: "handleTouchEnd",
                value: function handleTouchEnd() {
                    if (!this.isDragging) {
                        this.resetState();
                        return;
                    }

                    var dragDuration = Math.max(1, this.lastMoveAt - this.prevMoveAt);
                    var velocity = Math.max(0, this.lastY - this.prevY) / dragDuration;
                    var shouldClose = this.currentOffset >= this.getCloseDistance() || velocity >= BottomSheetSwipeClose.CLOSE_VELOCITY_PX_PER_MS;

                    if (shouldClose) {
                        this.closeWithAnimation();
                        return;
                    }

                    this.rollback();
                }
            }, {
                key: "handleTouchCancel",
                value: function handleTouchCancel() {
                    if (this.isDragging) {
                        this.rollback();
                        return;
                    }

                    this.resetState();
                }
            }, {
                key: "isAllowedStartTarget",
                value: function isAllowedStartTarget(target, clientY) {
                    if (this.elems.header && this.elems.header.contains(target)) {
                        return true;
                    }

                    if (!this.elems.content || !this.elems.content.contains(target)) {
                        return false;
                    }

                    var contentRect = this.elems.content.getBoundingClientRect();
                    return clientY <= contentRect.top + BottomSheetSwipeClose.START_ZONE_PX;
                }
            }, {
                key: "beginDrag",
                value: function beginDrag() {
                    this.isDragging = true;
                    this.modal.classList.add('modal2--swipe-dragging');

                    if (this.elems.content) {
                        this.elems.content.style.transition = 'none';
                        this.elems.content.style.willChange = 'transform';
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = 'none';
                        this.elems.footer.style.willChange = 'transform';
                    }
                    if (this.getOverlay()) {
                        this.getOverlay().style.transition = 'none';
                        this.getOverlay().style.willChange = 'opacity';
                    }
                }
            }, {
                key: "render",
                value: function render(offset) {
                    if (this.elems.content) {
                        this.elems.content.style.transform = "translateY(" + offset + "px)";
                    }

                    if (this.elems.footer) {
                        this.elems.footer.style.transform = "translateY(" + offset + "px)";
                    }

                    var overlay = this.getOverlay();
                    if (overlay) {
                        var opacity = Math.max(0, 1 - offset / Math.max(this.getContentHeight(), 1) * 1.6);
                        overlay.style.opacity = "" + opacity;
                    }
                }
            }, {
                key: "rollback",
                value: function rollback() {
                    var _this14 = this;

                    this.resetState();
                    this.animateTo(0, function () {
                        _this14.modal.classList.remove('modal2--swipe-dragging');
                        _this14.resetStyles();
                    });
                }
            }, {
                key: "closeWithAnimation",
                value: function closeWithAnimation() {
                    var _this15 = this;

                    if (this.isClosing) {
                        return;
                    }

                    this.isClosing = true;
                    this.resetState();
                    this.modal.dataset.swipeClosing = '1';

                    this.animateTo(window.innerHeight, function () {
                        if (_this15.onClose) {
                            _this15.onClose();
                        }
                    }, true);
                }
            }, {
                key: "animateTo",
                value: function animateTo(offset, onComplete) {
                    var _this16 = this;

                    var hideOverlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                    var transition = "transform " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease, opacity " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease";
                    var overlay = this.getOverlay();

                    if (this.elems.content) {
                        this.elems.content.style.transition = transition;
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = transition;
                    }
                    if (overlay) {
                        overlay.style.transition = "opacity " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease";
                    }

                    requestAnimationFrame(function () {
                        if (_this16.elems.content) {
                            _this16.elems.content.style.transform = offset > 0 ? "translateY(" + offset + "px)" : '';
                        }
                        if (_this16.elems.footer) {
                            _this16.elems.footer.style.transform = offset > 0 ? "translateY(" + offset + "px)" : '';
                        }
                        if (overlay) {
                            overlay.style.opacity = hideOverlay ? '0' : '';
                        }
                    });

                    this.resetAnimationTimer = setTimeout(function () {
                        _this16.resetAnimationTimer = null;
                        if (typeof onComplete === 'function') {
                            onComplete();
                        }
                    }, BottomSheetSwipeClose.CLOSE_ANIMATION_MS);
                }
            }, {
                key: "getCloseDistance",
                value: function getCloseDistance() {
                    return Math.min(140, Math.max(80, Math.round(this.getContentHeight() * 0.22)));
                }
            }, {
                key: "getContentHeight",
                value: function getContentHeight() {
                    return this.elems.content ? this.elems.content.getBoundingClientRect().height : window.innerHeight;
                }
            }, {
                key: "getOverlay",
                value: function getOverlay() {
                    return this.modal ? this.modal.querySelector('.modal2-overlay') : null;
                }
            }, {
                key: "getScrollTop",
                value: function getScrollTop() {
                    return this.elems.content ? this.elems.content.scrollTop : 0;
                }
            }, {
                key: "resetState",
                value: function resetState() {
                    this.isPotentialDrag = false;
                    this.isDragging = false;
                    this.currentOffset = 0;
                }
            }, {
                key: "resetStyles",
                value: function resetStyles() {
                    var overlay = this.getOverlay();

                    if (this.elems.content) {
                        this.elems.content.style.transition = '';
                        this.elems.content.style.transform = '';
                        this.elems.content.style.willChange = '';
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = '';
                        this.elems.footer.style.transform = '';
                        this.elems.footer.style.willChange = '';
                    }
                    if (overlay) {
                        overlay.style.transition = '';
                        overlay.style.opacity = '';
                        overlay.style.willChange = '';
                    }

                    if (this.modal) {
                        this.modal.classList.remove('modal2--swipe-dragging');
                    }
                }
            }], [{
                key: "START_ZONE_PX",
                get: function get() {
                    return 50;
                }
            }, {
                key: "DRAG_START_PX",
                get: function get() {
                    return 6;
                }
            }, {
                key: "CLOSE_VELOCITY_PX_PER_MS",
                get: function get() {
                    return 0.45;
                }
            }, {
                key: "CLOSE_ANIMATION_MS",
                get: function get() {
                    return 220;
                }
            }]);

            return BottomSheetSwipeClose;
        }();

        module.exports = BottomSheetSwipeClose;
    }, {}], 2: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var MODAL_IN_CSS_CLASS = 'in';
        var OVERFLOW_HIDDEN_CSS_CLASS = 'overflow-hidden';
        var BottomSheetSwipeClose = require('./BottomSheetSwipeClose');

        // TODO: добавить события начала и конца анимации показа/скрытия
        // Иногда нужно для того же сафари
        var events = {
            // Модалка создана и вставлена в DOM
            beforeShow: 'show.modal',
            // В модалку вставлен/загружен контент.
            // Анимация еще может быть не завершена или только начинаться
            afterShow: 'shown.modal',
            // Запущено закрытие модалки (старт)
            beforeHide: 'hide.modal',
            // Сразу по окончании анимации закрытия,
            // (До возвращения detachSelectorId контента в DOM и до удаления самой модалки из DOM)
            afterHide: 'hidden.modal'
        };

        var ModalItem = function () {
            /**
             * @param {HtModalOptions} params
             */
            function ModalItem(params) {
                _classCallCheck(this, ModalItem);

                this.params = params;
                if (params.content.htmlDetachSelectorId.length) {
                    var content = document.getElementById(params.content.htmlDetachSelectorId);
                    this.contentDetachedParent = content.parentNode;
                    this.content = this.content = content.parentNode.removeChild(content); // Detach the content
                } else {
                    this.content = params.content.html;
                    this.contentDetachedParent = null;
                }

                this.modal = document.querySelector(this.getTargetSelector());
                this.modal.dataset.targetSelector = this.getTargetSelector();
                this.elems = {
                    header: this.modal.querySelector('.modal2-header'),
                    footer: this.modal.querySelector('.modal2-footer'),
                    content: this.modal.querySelector('.modal2-content'), // scrollable
                    body: this.modal.querySelector('.modal2-body'),
                    title: this.modal.querySelector('.modal2-header .title')
                };
                this.bottomSheetSwipeClose = null;
            }

            _createClass(ModalItem, [{
                key: "getTargetSelector",
                value: function getTargetSelector() {
                    return '#' + this.params.id;
                }

                /**
                 * @param {boolean|null} showHeader
                 * @param {boolean|null} showFooter
                 */

            }, {
                key: "toggleStickyButtons",
                value: function toggleStickyButtons() {
                    var showHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var showFooter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    if (showHeader !== null && this.$elems.header.length) {
                        this.$elems.header.toggleClass('hidden', !showHeader);
                    }
                    if (showFooter !== null && this.$elems.footer.length) {
                        this.$elems.footer.toggleClass('hidden', !showFooter);
                    }
                }

                /**
                 * @param {string} title
                 */

            }, {
                key: "setTitle",
                value: function setTitle(title) {
                    if (this.elems.header) {
                        var header = this.elems.header;
                        var label = this.params.labelFor ? header.querySelector('.modal2-title__label') : [];
                        if (label.length === 0) {
                            label = header.querySelector('.modal2-title');
                        }
                        label.innerHTML = title;
                    }
                }
            }, {
                key: "show",
                value: function show() {
                    var _this17 = this;

                    document.body.classList.add('modal2-shown', OVERFLOW_HIDDEN_CSS_CLASS);
                    this.modal.classList.add('open');

                    setTimeout(function () {
                        _this17.modal.classList.add(MODAL_IN_CSS_CLASS);
                    }, 10);
                }
            }, {
                key: "loadContent",
                value: function loadContent() {
                    var _this18 = this;

                    // Trigger the beforeShow event
                    var beforeShowEvent = new CustomEvent('beforeShow');
                    this.modal.dispatchEvent(beforeShowEvent);
                    this.initBottomSheetSwipeClose();

                    if (this.params.content.url.length) {
                        // Set loader HTML
                        this.elems.body.innerHTML = this.getLoaderHTML();

                        // Fetch content from the URL
                        fetch(this.params.content.url).then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.text();
                        }).then(function (data) {
                            // Set the body content
                            _this18.elems.body.innerHTML = data;

                            if (_this18.params.onAfterShow) {
                                _this18.params.onAfterShow(_this18.modal);
                            }

                            // Optionally style here

                            // Trigger the afterShow event
                            var afterShowEvent = new CustomEvent('afterShow');
                            _this18.modal.dispatchEvent(afterShowEvent);
                        }).catch(function (error) {
                            _this18.showError({
                                header: _this18.elems.header,
                                content: _this18.elems.body,
                                text: error.message // Use error message
                            });
                        });
                    } else {
                        if (this.content instanceof HTMLElement) {
                            this.elems.body.innerHTML = ''; // Очистим содержимое
                            this.elems.body.appendChild(this.content); // Вставляем DOM-элемент
                        } else if (typeof this.content === 'string') {
                            this.elems.body.innerHTML = this.content;
                        }
                        if (this.params.onAfterShow) {
                            this.params.onAfterShow(this.modal);
                        }
                        // Trigger the afterShow event
                        var afterShowEvent = new CustomEvent('afterShow');
                        this.modal.dispatchEvent(afterShowEvent);
                    }

                    return true;
                }
            }, {
                key: "getLoaderHTML",
                value: function getLoaderHTML() {
                    return '<div class="loading-container loading-container--' + this.params.type + '">' + window.app.loading.circle + '</div>';
                }
            }, {
                key: "showError",
                value: function showError(params) {
                    var $content = params.content;
                    var text = params.text || 'Попробуйте позднее';

                    $content.html('<div class="site-error side-indent text-center">' + '<h2 class="site-header fw-b">Ошибка</h2>' + '<div class="site-error-description">' + text + '</div>' + '</div>');
                }
            }, {
                key: "hide",
                value: function hide() {
                    var _this19 = this;

                    var body = document.body;
                    var preserveSwipeStyles = this.modal.dataset.swipeClosing === '1';

                    if (this.bottomSheetSwipeClose) {
                        this.bottomSheetSwipeClose.destroy({ preserveStyles: preserveSwipeStyles });
                        this.bottomSheetSwipeClose = null;
                    }

                    // Hide started
                    var beforeHideEvent = new CustomEvent('beforeHide');
                    this.modal.dispatchEvent(beforeHideEvent);

                    if (typeof this.params.onBeforeClose === 'function') {
                        this.params.onBeforeClose(this.modal);
                    }

                    this.modal.classList.remove(MODAL_IN_CSS_CLASS);
                    setTimeout(function () {
                        _this19.modal.classList.remove('open');
                        var openedPopups = document.querySelectorAll('.modal2.open');

                        if (!openedPopups.length) {
                            body.classList.remove('modal2-shown', OVERFLOW_HIDDEN_CSS_CLASS);
                        }

                        // hidden. Call after restoring scroll on body
                        var afterHideEvent = new CustomEvent('afterHide');
                        _this19.modal.dispatchEvent(afterHideEvent);

                        if (_this19.params.content.htmlDetachSelectorId.length) {
                            var contentToDetach = document.getElementById(_this19.params.content.htmlDetachSelectorId);
                            if (contentToDetach) {
                                _this19.contentDetachedParent.innerHTML = ''; // Clear the content first
                                _this19.contentDetachedParent.appendChild(contentToDetach); // Append detached content
                            }
                        }

                        // Removal
                        if (typeof _this19.params.onBeforeRemove === 'function') {
                            _this19.params.onBeforeRemove(_this19.modal);
                        }
                        delete _this19.modal.dataset.swipeClosing;
                        _this19.modal.remove();
                    }, this.params.animationDuration);
                }
            }, {
                key: "initBottomSheetSwipeClose",
                value: function initBottomSheetSwipeClose() {
                    var _this20 = this;

                    if (this.bottomSheetSwipeClose || this.params.type !== 'bottom') {
                        return;
                    }

                    this.bottomSheetSwipeClose = new BottomSheetSwipeClose(this.modal, this.elems, function () {
                        if (window.modal && typeof window.modal.close === 'function') {
                            window.modal.close(_this20.getTargetSelector());
                        }
                    });
                    this.bottomSheetSwipeClose.init();
                }

                // Корректный селектор

            }, {
                key: "isTargetValid",
                value: function isTargetValid() {
                    return this.modal && this.modal.classList.contains('modal2');
                }
            }]);

            return ModalItem;
        }();

        module.exports = {
            ModalItem: ModalItem,
            itemConstants: {
                IN_CSS_CLASS: MODAL_IN_CSS_CLASS
            },
            events: events
        };
    }, { "./BottomSheetSwipeClose": 1 }] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var BottomSheetSwipeClose = function () {
            function BottomSheetSwipeClose(modal, elems) {
                var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                _classCallCheck(this, BottomSheetSwipeClose);

                this.modal = modal;
                this.elems = elems || {};
                this.onClose = typeof onClose === 'function' ? onClose : null;

                this.startY = 0;
                this.startX = 0;
                this.startScrollTop = 0;
                this.lastY = 0;
                this.lastMoveAt = 0;
                this.prevY = 0;
                this.prevMoveAt = 0;
                this.currentOffset = 0;

                this.isPotentialDrag = false;
                this.isDragging = false;
                this.isClosing = false;
                this.resetAnimationTimer = null;

                this.onTouchStart = this.handleTouchStart.bind(this);
                this.onTouchMove = this.handleTouchMove.bind(this);
                this.onTouchEnd = this.handleTouchEnd.bind(this);
                this.onTouchCancel = this.handleTouchCancel.bind(this);
            }

            _createClass(BottomSheetSwipeClose, [{
                key: "init",
                value: function init() {
                    if (!this.isEnabled() || !this.modal) {
                        return;
                    }

                    this.modal.addEventListener('touchstart', this.onTouchStart, { passive: true });
                    this.modal.addEventListener('touchmove', this.onTouchMove, { passive: false });
                    this.modal.addEventListener('touchend', this.onTouchEnd, { passive: true });
                    this.modal.addEventListener('touchcancel', this.onTouchCancel, { passive: true });
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                        _ref5$preserveStyles = _ref5.preserveStyles,
                        preserveStyles = _ref5$preserveStyles === undefined ? false : _ref5$preserveStyles;

                    if (!this.modal) {
                        return;
                    }

                    this.modal.removeEventListener('touchstart', this.onTouchStart);
                    this.modal.removeEventListener('touchmove', this.onTouchMove);
                    this.modal.removeEventListener('touchend', this.onTouchEnd);
                    this.modal.removeEventListener('touchcancel', this.onTouchCancel);

                    if (this.resetAnimationTimer) {
                        clearTimeout(this.resetAnimationTimer);
                        this.resetAnimationTimer = null;
                    }

                    this.resetState();
                    if (!preserveStyles) {
                        this.resetStyles();
                    }
                }
            }, {
                key: "isEnabled",
                value: function isEnabled() {
                    return !!(this.modal && this.modal.classList && this.modal.classList.contains('modal2--bottom') && this.elems.content);
                }
            }, {
                key: "handleTouchStart",
                value: function handleTouchStart(event) {
                    if (!this.isEnabled() || this.isClosing || !event.touches || event.touches.length !== 1) {
                        return;
                    }

                    var touch = event.touches[0];
                    var target = event.target instanceof Element ? event.target : null;
                    if (!target || !this.isAllowedStartTarget(target, touch.clientY)) {
                        return;
                    }

                    var scrollTop = this.getScrollTop();
                    if (scrollTop > 0) {
                        return;
                    }

                    this.startY = touch.clientY;
                    this.startX = touch.clientX;
                    this.lastY = touch.clientY;
                    this.lastMoveAt = Date.now();
                    this.prevY = touch.clientY;
                    this.prevMoveAt = this.lastMoveAt;
                    this.startScrollTop = scrollTop;
                    this.currentOffset = 0;
                    this.isPotentialDrag = true;
                    this.isDragging = false;
                }
            }, {
                key: "handleTouchMove",
                value: function handleTouchMove(event) {
                    if (!this.isPotentialDrag && !this.isDragging || !event.touches || event.touches.length !== 1) {
                        return;
                    }

                    var touch = event.touches[0];
                    var deltaY = touch.clientY - this.startY;
                    var deltaX = touch.clientX - this.startX;

                    this.prevY = this.lastY;
                    this.prevMoveAt = this.lastMoveAt;
                    this.lastY = touch.clientY;
                    this.lastMoveAt = Date.now();

                    if (!this.isDragging) {
                        if (Math.abs(deltaY) < BottomSheetSwipeClose.DRAG_START_PX) {
                            return;
                        }

                        if (Math.abs(deltaX) > Math.abs(deltaY) || deltaY <= 0 || this.startScrollTop > 0 || this.getScrollTop() > 0) {
                            this.resetState();
                            return;
                        }

                        this.beginDrag();
                    }

                    event.preventDefault();

                    var offset = Math.max(0, deltaY);
                    this.currentOffset = offset;
                    this.render(offset);
                }
            }, {
                key: "handleTouchEnd",
                value: function handleTouchEnd() {
                    if (!this.isDragging) {
                        this.resetState();
                        return;
                    }

                    var dragDuration = Math.max(1, this.lastMoveAt - this.prevMoveAt);
                    var velocity = Math.max(0, this.lastY - this.prevY) / dragDuration;
                    var shouldClose = this.currentOffset >= this.getCloseDistance() || velocity >= BottomSheetSwipeClose.CLOSE_VELOCITY_PX_PER_MS;

                    if (shouldClose) {
                        this.closeWithAnimation();
                        return;
                    }

                    this.rollback();
                }
            }, {
                key: "handleTouchCancel",
                value: function handleTouchCancel() {
                    if (this.isDragging) {
                        this.rollback();
                        return;
                    }

                    this.resetState();
                }
            }, {
                key: "isAllowedStartTarget",
                value: function isAllowedStartTarget(target, clientY) {
                    if (this.elems.header && this.elems.header.contains(target)) {
                        return true;
                    }

                    if (!this.elems.content || !this.elems.content.contains(target)) {
                        return false;
                    }

                    var contentRect = this.elems.content.getBoundingClientRect();
                    return clientY <= contentRect.top + BottomSheetSwipeClose.START_ZONE_PX;
                }
            }, {
                key: "beginDrag",
                value: function beginDrag() {
                    this.isDragging = true;
                    this.modal.classList.add('modal2--swipe-dragging');

                    if (this.elems.content) {
                        this.elems.content.style.transition = 'none';
                        this.elems.content.style.willChange = 'transform';
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = 'none';
                        this.elems.footer.style.willChange = 'transform';
                    }
                    if (this.getOverlay()) {
                        this.getOverlay().style.transition = 'none';
                        this.getOverlay().style.willChange = 'opacity';
                    }
                }
            }, {
                key: "render",
                value: function render(offset) {
                    if (this.elems.content) {
                        this.elems.content.style.transform = "translateY(" + offset + "px)";
                    }

                    if (this.elems.footer) {
                        this.elems.footer.style.transform = "translateY(" + offset + "px)";
                    }

                    var overlay = this.getOverlay();
                    if (overlay) {
                        var opacity = Math.max(0, 1 - offset / Math.max(this.getContentHeight(), 1) * 1.6);
                        overlay.style.opacity = "" + opacity;
                    }
                }
            }, {
                key: "rollback",
                value: function rollback() {
                    var _this21 = this;

                    this.resetState();
                    this.animateTo(0, function () {
                        _this21.modal.classList.remove('modal2--swipe-dragging');
                        _this21.resetStyles();
                    });
                }
            }, {
                key: "closeWithAnimation",
                value: function closeWithAnimation() {
                    var _this22 = this;

                    if (this.isClosing) {
                        return;
                    }

                    this.isClosing = true;
                    this.resetState();
                    this.modal.dataset.swipeClosing = '1';

                    this.animateTo(window.innerHeight, function () {
                        if (_this22.onClose) {
                            _this22.onClose();
                        }
                    }, true);
                }
            }, {
                key: "animateTo",
                value: function animateTo(offset, onComplete) {
                    var _this23 = this;

                    var hideOverlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                    var transition = "transform " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease, opacity " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease";
                    var overlay = this.getOverlay();

                    if (this.elems.content) {
                        this.elems.content.style.transition = transition;
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = transition;
                    }
                    if (overlay) {
                        overlay.style.transition = "opacity " + BottomSheetSwipeClose.CLOSE_ANIMATION_MS + "ms ease";
                    }

                    requestAnimationFrame(function () {
                        if (_this23.elems.content) {
                            _this23.elems.content.style.transform = offset > 0 ? "translateY(" + offset + "px)" : '';
                        }
                        if (_this23.elems.footer) {
                            _this23.elems.footer.style.transform = offset > 0 ? "translateY(" + offset + "px)" : '';
                        }
                        if (overlay) {
                            overlay.style.opacity = hideOverlay ? '0' : '';
                        }
                    });

                    this.resetAnimationTimer = setTimeout(function () {
                        _this23.resetAnimationTimer = null;
                        if (typeof onComplete === 'function') {
                            onComplete();
                        }
                    }, BottomSheetSwipeClose.CLOSE_ANIMATION_MS);
                }
            }, {
                key: "getCloseDistance",
                value: function getCloseDistance() {
                    return Math.min(140, Math.max(80, Math.round(this.getContentHeight() * 0.22)));
                }
            }, {
                key: "getContentHeight",
                value: function getContentHeight() {
                    return this.elems.content ? this.elems.content.getBoundingClientRect().height : window.innerHeight;
                }
            }, {
                key: "getOverlay",
                value: function getOverlay() {
                    return this.modal ? this.modal.querySelector('.modal2-overlay') : null;
                }
            }, {
                key: "getScrollTop",
                value: function getScrollTop() {
                    return this.elems.content ? this.elems.content.scrollTop : 0;
                }
            }, {
                key: "resetState",
                value: function resetState() {
                    this.isPotentialDrag = false;
                    this.isDragging = false;
                    this.currentOffset = 0;
                }
            }, {
                key: "resetStyles",
                value: function resetStyles() {
                    var overlay = this.getOverlay();

                    if (this.elems.content) {
                        this.elems.content.style.transition = '';
                        this.elems.content.style.transform = '';
                        this.elems.content.style.willChange = '';
                    }
                    if (this.elems.footer) {
                        this.elems.footer.style.transition = '';
                        this.elems.footer.style.transform = '';
                        this.elems.footer.style.willChange = '';
                    }
                    if (overlay) {
                        overlay.style.transition = '';
                        overlay.style.opacity = '';
                        overlay.style.willChange = '';
                    }

                    if (this.modal) {
                        this.modal.classList.remove('modal2--swipe-dragging');
                    }
                }
            }], [{
                key: "START_ZONE_PX",
                get: function get() {
                    return 50;
                }
            }, {
                key: "DRAG_START_PX",
                get: function get() {
                    return 6;
                }
            }, {
                key: "CLOSE_VELOCITY_PX_PER_MS",
                get: function get() {
                    return 0.45;
                }
            }, {
                key: "CLOSE_ANIMATION_MS",
                get: function get() {
                    return 220;
                }
            }]);

            return BottomSheetSwipeClose;
        }();

        module.exports = BottomSheetSwipeClose;
    }, {}], 2: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var MODAL_IN_CSS_CLASS = 'in';
        var OVERFLOW_HIDDEN_CSS_CLASS = 'overflow-hidden';
        var BottomSheetSwipeClose = require('./BottomSheetSwipeClose');

        // TODO: добавить события начала и конца анимации показа/скрытия
        // Иногда нужно для того же сафари
        var events = {
            // Модалка создана и вставлена в DOM
            beforeShow: 'show.modal',
            // В модалку вставлен/загружен контент.
            // Анимация еще может быть не завершена или только начинаться
            afterShow: 'shown.modal',
            // Запущено закрытие модалки (старт)
            beforeHide: 'hide.modal',
            // Сразу по окончании анимации закрытия,
            // (До возвращения detachSelectorId контента в DOM и до удаления самой модалки из DOM)
            afterHide: 'hidden.modal'
        };

        var ModalItem = function () {
            /**
             * @param {HtModalOptions} params
             */
            function ModalItem(params) {
                _classCallCheck(this, ModalItem);

                this.params = params;
                if (params.content.htmlDetachSelectorId.length) {
                    var content = document.getElementById(params.content.htmlDetachSelectorId);
                    this.contentDetachedParent = content.parentNode;
                    this.content = this.content = content.parentNode.removeChild(content); // Detach the content
                } else {
                    this.content = params.content.html;
                    this.contentDetachedParent = null;
                }

                this.modal = document.querySelector(this.getTargetSelector());
                this.modal.dataset.targetSelector = this.getTargetSelector();
                this.elems = {
                    header: this.modal.querySelector('.modal2-header'),
                    footer: this.modal.querySelector('.modal2-footer'),
                    content: this.modal.querySelector('.modal2-content'), // scrollable
                    body: this.modal.querySelector('.modal2-body'),
                    title: this.modal.querySelector('.modal2-header .title')
                };
                this.bottomSheetSwipeClose = null;
            }

            _createClass(ModalItem, [{
                key: "getTargetSelector",
                value: function getTargetSelector() {
                    return '#' + this.params.id;
                }

                /**
                 * @param {boolean|null} showHeader
                 * @param {boolean|null} showFooter
                 */

            }, {
                key: "toggleStickyButtons",
                value: function toggleStickyButtons() {
                    var showHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var showFooter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    if (showHeader !== null && this.$elems.header.length) {
                        this.$elems.header.toggleClass('hidden', !showHeader);
                    }
                    if (showFooter !== null && this.$elems.footer.length) {
                        this.$elems.footer.toggleClass('hidden', !showFooter);
                    }
                }

                /**
                 * @param {string} title
                 */

            }, {
                key: "setTitle",
                value: function setTitle(title) {
                    if (this.elems.header) {
                        var header = this.elems.header;
                        var label = this.params.labelFor ? header.querySelector('.modal2-title__label') : [];
                        if (label.length === 0) {
                            label = header.querySelector('.modal2-title');
                        }
                        label.innerHTML = title;
                    }
                }
            }, {
                key: "show",
                value: function show() {
                    var _this24 = this;

                    document.body.classList.add('modal2-shown', OVERFLOW_HIDDEN_CSS_CLASS);
                    this.modal.classList.add('open');

                    setTimeout(function () {
                        _this24.modal.classList.add(MODAL_IN_CSS_CLASS);
                    }, 10);
                }
            }, {
                key: "loadContent",
                value: function loadContent() {
                    var _this25 = this;

                    // Trigger the beforeShow event
                    var beforeShowEvent = new CustomEvent('beforeShow');
                    this.modal.dispatchEvent(beforeShowEvent);
                    this.initBottomSheetSwipeClose();

                    if (this.params.content.url.length) {
                        // Set loader HTML
                        this.elems.body.innerHTML = this.getLoaderHTML();

                        // Fetch content from the URL
                        fetch(this.params.content.url).then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.text();
                        }).then(function (data) {
                            // Set the body content
                            _this25.elems.body.innerHTML = data;

                            if (_this25.params.onAfterShow) {
                                _this25.params.onAfterShow(_this25.modal);
                            }

                            // Optionally style here

                            // Trigger the afterShow event
                            var afterShowEvent = new CustomEvent('afterShow');
                            _this25.modal.dispatchEvent(afterShowEvent);
                        }).catch(function (error) {
                            _this25.showError({
                                header: _this25.elems.header,
                                content: _this25.elems.body,
                                text: error.message // Use error message
                            });
                        });
                    } else {
                        if (this.content instanceof HTMLElement) {
                            this.elems.body.innerHTML = ''; // Очистим содержимое
                            this.elems.body.appendChild(this.content); // Вставляем DOM-элемент
                        } else if (typeof this.content === 'string') {
                            this.elems.body.innerHTML = this.content;
                        }
                        if (this.params.onAfterShow) {
                            this.params.onAfterShow(this.modal);
                        }
                        // Trigger the afterShow event
                        var afterShowEvent = new CustomEvent('afterShow');
                        this.modal.dispatchEvent(afterShowEvent);
                    }

                    return true;
                }
            }, {
                key: "getLoaderHTML",
                value: function getLoaderHTML() {
                    return '<div class="loading-container loading-container--' + this.params.type + '">' + window.app.loading.circle + '</div>';
                }
            }, {
                key: "showError",
                value: function showError(params) {
                    var $content = params.content;
                    var text = params.text || 'Попробуйте позднее';

                    $content.html('<div class="site-error side-indent text-center">' + '<h2 class="site-header fw-b">Ошибка</h2>' + '<div class="site-error-description">' + text + '</div>' + '</div>');
                }
            }, {
                key: "hide",
                value: function hide() {
                    var _this26 = this;

                    var body = document.body;
                    var preserveSwipeStyles = this.modal.dataset.swipeClosing === '1';

                    if (this.bottomSheetSwipeClose) {
                        this.bottomSheetSwipeClose.destroy({ preserveStyles: preserveSwipeStyles });
                        this.bottomSheetSwipeClose = null;
                    }

                    // Hide started
                    var beforeHideEvent = new CustomEvent('beforeHide');
                    this.modal.dispatchEvent(beforeHideEvent);

                    if (typeof this.params.onBeforeClose === 'function') {
                        this.params.onBeforeClose(this.modal);
                    }

                    this.modal.classList.remove(MODAL_IN_CSS_CLASS);
                    setTimeout(function () {
                        _this26.modal.classList.remove('open');
                        var openedPopups = document.querySelectorAll('.modal2.open');

                        if (!openedPopups.length) {
                            body.classList.remove('modal2-shown', OVERFLOW_HIDDEN_CSS_CLASS);
                        }

                        // hidden. Call after restoring scroll on body
                        var afterHideEvent = new CustomEvent('afterHide');
                        _this26.modal.dispatchEvent(afterHideEvent);

                        if (_this26.params.content.htmlDetachSelectorId.length) {
                            var contentToDetach = document.getElementById(_this26.params.content.htmlDetachSelectorId);
                            if (contentToDetach) {
                                _this26.contentDetachedParent.innerHTML = ''; // Clear the content first
                                _this26.contentDetachedParent.appendChild(contentToDetach); // Append detached content
                            }
                        }

                        // Removal
                        if (typeof _this26.params.onBeforeRemove === 'function') {
                            _this26.params.onBeforeRemove(_this26.modal);
                        }
                        delete _this26.modal.dataset.swipeClosing;
                        _this26.modal.remove();
                    }, this.params.animationDuration);
                }
            }, {
                key: "initBottomSheetSwipeClose",
                value: function initBottomSheetSwipeClose() {
                    var _this27 = this;

                    if (this.bottomSheetSwipeClose || this.params.type !== 'bottom') {
                        return;
                    }

                    this.bottomSheetSwipeClose = new BottomSheetSwipeClose(this.modal, this.elems, function () {
                        if (window.modal && typeof window.modal.close === 'function') {
                            window.modal.close(_this27.getTargetSelector());
                        }
                    });
                    this.bottomSheetSwipeClose.init();
                }

                // Корректный селектор

            }, {
                key: "isTargetValid",
                value: function isTargetValid() {
                    return this.modal && this.modal.classList.contains('modal2');
                }
            }]);

            return ModalItem;
        }();

        module.exports = {
            ModalItem: ModalItem,
            itemConstants: {
                IN_CSS_CLASS: MODAL_IN_CSS_CLASS
            },
            events: events
        };
    }, { "./BottomSheetSwipeClose": 1 }], 3: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var _require3 = require('./ModalItem'),
            ModalItem = _require3.ModalItem,
            itemConstants = _require3.itemConstants;

        var itemRender = require('./options/modal-item-render');
        var zIndex = 1000;

        var goBackDebugTimer = 0;

        function dispatchDebugEvent(message) {
            if (window.app.debug) {
                var event = new CustomEvent('modal.debugAlert', {
                    detail: {
                        message: message
                    }
                });
                window.dispatchEvent(event);
            }
        }

        var ModalManager = function () {
            function ModalManager() {
                _classCallCheck(this, ModalManager);

                if (window.modal) {
                    throw new Error('only one instance of ModalManager available');
                }

                /**
                 * @type {number}
                 */
                this.loadingTimestamp = new Date().getTime();

                /**
                 * Поддерживаем ли работу с history API
                 * @type {boolean}
                 */
                this.isHistorySupported = typeof window.history !== 'undefined';

                /**
                 * Когда идет одновременно закрытие history.go(-1) и открытие history.pushState({...})
                 * Блочим открытие до момента, пока не закончится закрытие
                 * @type {number}
                 */
                this.historyPushLockTimer = 0;

                /**
                 * Если пытались что-то открыть в момент, пока открытие было заблочено - откладываем
                 * @type {Array}
                 */
                this.delayedOpenExecution = [];

                /**
                 * z-index модалки
                 * @type {number}
                 */
                this.zIndex = 1000;

                /**
                 * кол-во модалок, открытых на текущий момент
                 * @type {number}
                 */
                this.visibleCount = 0;

                /**
                 * Кол-во модалок, открытых в пределах визита (1 страницы)
                 * ++ при открытии каждой новой модалки
                 * По совместитульству уникальный идетфикатор модалки
                 * @type {number}
                 */
                this.shownCount = 0;

                /**
                 * @type {{}}
                 */
                this.openedItemsByIndex = {};

                /**
                 * Отслеживаем только после загрузки страницы
                 * По history.state нельзя ориентироваться. На момент собыния popstate уже новое состояние
                 * @type {null|any}
                 */
                this.currentHistoryState = null;

                /**
                 * От срабатывания несколько раз .go(-1)
                 * @type {{}}
                 */
                this.popupCloseLocked = {};

                /**
                 * @type {ModalItem}
                 */
                this.closeTargetItem = null;

                this.attachHandlers();
            }

            /**
             * @param {HtModalOptions} options
             * @param {boolean} ignoreLock
             * @return {boolean}
             */


            _createClass(ModalManager, [{
                key: "open",
                value: function open(options) {
                    var _this28 = this;

                    var ignoreLock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    if (!options.validate()) {
                        return false;
                    }
                    if (this.isHistorySupported) {
                        if (this.historyPushLockTimer && !ignoreLock) {
                            // Откладываем выполнение
                            this.delayedOpenExecution.push(function () {
                                _this28.open(options, true);
                            });

                            console.info('modal open postponed dew to history API conflict');
                            return false;
                        }
                    }

                    // render modal
                    document.body.appendChild(itemRender(options, zIndex++));

                    var modalItem = new ModalItem(options);
                    if (!modalItem.isTargetValid()) {
                        console.error('Something went wrong. Can`t open modal');
                        return false;
                    }

                    // Анимация показа
                    modalItem.show();
                    // Если модалка не показана
                    if (!this._isOpenedNow(modalItem)) {
                        this.visibleCount++;
                        this.shownCount++;

                        this.openedItemsByIndex[this.shownCount] = modalItem;
                        modalItem.modal.dataset.index = this.shownCount;

                        if (this.isHistorySupported) {
                            // Была закрыта. Показываем
                            this._unlockClose(modalItem.getTargetSelector());
                            history.pushState({
                                type: 'modal',
                                index: this.shownCount,
                                sessionTimestamp: this.loadingTimestamp
                            }, document.title);
                        }
                    } else {
                        console.warn('requested modal is already opened');
                        // Закрываем все что открыто после,
                        // Чтобы вернуть history.state к состоянию текущей модалки
                        // TODO:
                    }
                    modalItem.loadContent();

                    return true;
                }

                /**
                 * Закрытие модалки с кнопки в интерфейсе
                 * @param self
                 * @param {*} popupSelector - Не используется при включенной истории
                 */

            }, {
                key: "close",
                value: function close(self, popupSelector) {
                    var popup = null;
                    if (typeof popupSelector !== 'undefined' && popupSelector !== null) {
                        popup = document.querySelector(popupSelector);
                    } else {
                        popup = self.closest('.modal2');
                    }

                    popupSelector = popup.dataset.targetSelector; // Accessing the data attribute
                    var targetModalItem = this._getOpenedModalItemByElement(popup);

                    if (this.isHistorySupported) {
                        if (this.haveOpened()) {
                            var currentState = this._parseCurrentState();
                            var closeTargetSelector = currentState.targetModalItem.getTargetSelector();
                            if (!targetModalItem) {
                                console.warn('target modal "%s" is not opened', popupSelector);
                                console.warn('last opened now is "%s"', closeTargetSelector);
                            } else {
                                if (closeTargetSelector !== targetModalItem.getTargetSelector()) {
                                    console.warn('target modal "%s" is opened (not last opened)', popupSelector);
                                    console.warn('last opened now is "%s"', closeTargetSelector);
                                }
                            }
                            if (!popup.classList.contains(itemConstants.IN_CSS_CLASS)) {
                                // If the modal where the button was clicked or passed as a selector is closed
                                console.warn('blocked close for "%s"', closeTargetSelector);
                                return;
                            }
                        }
                        // Close the last opened modal
                        this._closeLast();
                    } else {
                        this.closeTargetItem = targetModalItem;
                        this._runClose();
                    }

                    return true;
                }
            }, {
                key: "_closeLast",
                value: function _closeLast() {
                    if (!this.isHistorySupported) {
                        return false;
                    }
                    var self = this;
                    var currentState = this._parseCurrentState();
                    if (currentState.targetModalItem) {
                        // От двойных срабатываний .go(-1) при закрытии одной и той же модалки
                        // При следующем открытии снимаем флаг
                        if (!this._isCloseLocked(currentState.targetModalItem.getTargetSelector())) {
                            this._lockClose(currentState.targetModalItem.getTargetSelector());

                            if (this.historyPushLockTimer) {
                                clearTimeout(this.historyPushLockTimer);
                                this.historyPushLockTimer = 0;
                            }

                            this.historyPushLockTimer = setTimeout(function () {
                                self._onAfterHistoryPushUnlock();
                            }, 10);

                            goBackDebugTimer = setTimeout(function () {
                                dispatchDebugEvent('modal popstate event was not fired after 100ms from go(-1)');
                            }, 100);

                            // Закрытие в popstate
                            // Закрывает модалку из this._parseCurrentState();
                            history.go(-1);

                            return true;
                        } else if (window.app.debug) {
                            dispatchDebugEvent('modal close locked. consider check onpopstate event listener');
                        }
                    }

                    return false;
                }
            }, {
                key: "_runClose",
                value: function _runClose() {
                    var modalItem = this.closeTargetItem;
                    if (!modalItem || !this._isOpenedNow(modalItem)) {
                        return false;
                    }
                    var openedModalIndex = modalItem.modal.dataset.index; // Accessing the data attribute
                    delete this.openedItemsByIndex[openedModalIndex];

                    if (this.visibleCount) {
                        this.visibleCount--;
                    }

                    if (this.visibleCount === 0) {
                        this.openedItemsByIndex = {};
                    }

                    // Set default
                    this.closeTargetItem = null;

                    modalItem.hide(); // Assuming hide() is a method on modalItem
                }
            }, {
                key: "haveOpened",
                value: function haveOpened() {
                    return this.visibleCount > 0;
                }
            }, {
                key: "attachHandlers",
                value: function attachHandlers() {
                    var _this29 = this;

                    if (this.isHistorySupported) {
                        this._attachHistoryStateHandlers();
                    }
                    document.addEventListener('DOMContentLoaded', function () {
                        _this29._attachDOMHandlers();
                    });
                }
            }, {
                key: "_attachDOMHandlers",
                value: function _attachDOMHandlers() {
                    var _this30 = this;

                    var self = this;
                    document.body.addEventListener('click', function (e) {
                        var closeBtn = e.target.closest('.modal2-close');
                        var overlay = e.target.closest('.modal2-overlay');

                        if (closeBtn || overlay) {
                            _this30.close(closeBtn || overlay);
                        }
                    });
                }
            }, {
                key: "_attachHistoryStateHandlers",
                value: function _attachHistoryStateHandlers() {
                    if (!this.isHistorySupported) {
                        return false;
                    }

                    var self = this;
                    (function (history) {
                        var pushState = history.pushState;
                        history.pushState = function (state) {
                            self._onPushState({
                                state: state
                            });
                            return pushState.apply(history, arguments);
                        };
                    })(window.history);

                    window.addEventListener('popstate', function (e) {
                        self._onPopState(e);
                    }, false);

                    return true;
                }
            }, {
                key: "_onPushState",
                value: function _onPushState(e) {
                    this.currentHistoryState = e.state;
                }
            }, {
                key: "_onPopState",
                value: function _onPopState(e) {
                    if (goBackDebugTimer) {
                        clearTimeout(goBackDebugTimer);
                    }
                    // Предыдущее состояние, до popstate
                    var previousState = this._parseCurrentState();
                    // Обновляем текущее состояние истории
                    this.currentHistoryState = e.state;

                    if (this.haveOpened() && previousState.isCurrentSessionState && previousState.targetModalItem) {
                        // Если в предыдущем состоянии была наша модалка - закрываем
                        this.closeTargetItem = previousState.targetModalItem;
                        this._runClose();
                    }
                }

                /**
                 * @return {{isModalState: boolean, isCurrentSessionState: boolean, targetModalItem: ModalItem}}
                 * @private
                 */

            }, {
                key: "_parseCurrentState",
                value: function _parseCurrentState() {
                    var state = this.currentHistoryState;
                    var isModalState = state !== null && (typeof state === "undefined" ? "undefined" : _typeof(state)) === 'object' && state.type === 'modal';
                    var isCurrentSessionState = isModalState && state.sessionTimestamp === this.loadingTimestamp;

                    return {
                        isModalState: isModalState,
                        isCurrentSessionState: isCurrentSessionState,
                        targetModalItem: isCurrentSessionState ? this._getOpenedModalItemByIndex(state.index) : null
                    };
                }

                /**
                 *
                 * @param index
                 * @return {ModalItem|null}
                 * @private
                 */

            }, {
                key: "_getOpenedModalItemByIndex",
                value: function _getOpenedModalItemByIndex(index) {
                    return this.openedItemsByIndex[index] || null;
                }

                /**
                 *
                 * @param $modal
                 * @return {ModalItem|null}
                 * @private
                 */

            }, {
                key: "_getOpenedModalItemByElement",
                value: function _getOpenedModalItemByElement($modal) {
                    var openedModalIndex = $modal && $modal.classList.contains('modal2') ? $modal.dataset.index : null;
                    var modalItem = this._getOpenedModalItemByIndex(openedModalIndex);
                    if (modalItem && this._isOpenedNow(modalItem)) {
                        return modalItem;
                    }

                    return null;
                }

                /**
                 * @param selector
                 * @return {ModalItem|null}
                 */

            }, {
                key: "getOpenedNowModalItemByChild",
                value: function getOpenedNowModalItemByChild(selector) {
                    var child = document.querySelector(selector);
                    if (child) {
                        return this._getOpenedModalItemByElement(child.closest('.modal2'));
                    }
                }
            }, {
                key: "_onAfterHistoryPushUnlock",
                value: function _onAfterHistoryPushUnlock() {
                    var len = this.delayedOpenExecution.length;
                    if (len) {
                        var i = void 0;
                        for (i = 0; i < len; i++) {
                            this.delayedOpenExecution[i]();
                        }
                        this.delayedOpenExecution = [];
                    }
                    this.historyPushLockTimer = 0;
                }

                // Для одной и той же модалки не делать go(-1) несколько раз,
                // пока снова не будет записи в источрии

            }, {
                key: "_lockClose",
                value: function _lockClose(popupSelector) {
                    this.popupCloseLocked[popupSelector] = 1;
                }

                // При новом открытии, вместе с pushState

            }, {
                key: "_unlockClose",
                value: function _unlockClose(popupSelector) {
                    this.popupCloseLocked[popupSelector] = 0;
                }

                // Уже вызвано событие закрытия для этой модалки.
                // Пока не закроется не вызывать history.go(-1) для этой модалки

            }, {
                key: "_isCloseLocked",
                value: function _isCloseLocked(popupSelector) {
                    return this.popupCloseLocked.hasOwnProperty(popupSelector) && this.popupCloseLocked[popupSelector] === 1;
                }
            }, {
                key: "_isOpenedNow",
                value: function _isOpenedNow(modalItem) {
                    var shownIndex = modalItem.modal.dataset.index; // Access data attribute directly
                    // if popup was shown sometime ago OR was shown and closed at least once
                    return shownIndex && this.openedItemsByIndex.hasOwnProperty(shownIndex);
                }
            }]);

            return ModalManager;
        }();

        module.exports = ModalManager;
    }, { "./ModalItem": 2, "./options/modal-item-render": 5 }], 4: [function (require, module, exports) {
        var SIZE_SM = 'sm';
        var THEME_DEFAULT = 'default';
        var THEME_SECONDARY = 'secondary';
        var THEME_TRANSPARENT = 'transparent';
        var THEME_PRIMARY = 'primary';
        var TYPE_FULL = 'full';
        var TYPE_BOTTOM = 'bottom';
        var TYPE_FLOATING = 'floating';

        module.exports = {
            SIZE_SM: SIZE_SM,
            THEME_DEFAULT: THEME_DEFAULT,
            THEME_SECONDARY: THEME_SECONDARY,
            THEME_TRANSPARENT: THEME_TRANSPARENT,
            THEME_PRIMARY: THEME_PRIMARY,
            TYPE_FULL: TYPE_FULL,
            TYPE_BOTTOM: TYPE_BOTTOM,
            TYPE_FLOATING: TYPE_FLOATING
        };
    }, {}], 5: [function (require, module, exports) {
        var _require4 = require('./constant'),
            THEME_TRANSPARENT = _require4.THEME_TRANSPARENT;

        /**
         * @param {HtModalOptions} options
         * @param {number} zIndex
         * @return {HTMLDivElement}
         */


        module.exports = function (options, zIndex) {
            var _popup$classList2, _overlay$classList2, _contentBody$classLis2;

            var popup = document.createElement('div');
            popup.id = options.id;
            var typeClass = options.type ? "modal2--" + options.type : null;
            var parentClasses = typeof options.parentCssClass === 'string' ? options.parentCssClass.split(/\s+/).filter(Boolean) : [];
            (_popup$classList2 = popup.classList).add.apply(_popup$classList2, _toConsumableArray(['modal2', typeClass].concat(_toConsumableArray(parentClasses)).filter(Boolean)));

            var overlay = document.createElement('div');
            overlay.setAttribute('role', 'button');
            (_overlay$classList2 = overlay.classList).add.apply(_overlay$classList2, ['modal2-overlay', 'modal2-overlay--blurred', 'fade-animation']);

            var content = options.content.render();
            if (options.fixContentMaxHeight) {
                content.classList.add('fix-max-height');
            }

            var isContentBg = true;
            if (options.header) {
                if (options.header.isSticky()) {
                    popup.classList.add('fixed-header');
                }
                // header внутри content для sticky
                content.append(options.header.render());
                isContentBg = !options.header.isTransparent();
            }

            var contentBody = document.createElement('div');
            (_contentBody$classLis2 = contentBody.classList).add.apply(_contentBody$classLis2, ['modal2-body']);
            if (options.footer && options.footer.height !== null) {
                contentBody.style.paddingBottom = options.footer.height + 'px';
            }
            if (isContentBg) {
                content.classList.add('theme-' + options.content.theme);
            } else {
                contentBody.classList.add('theme-' + options.content.theme);
                contentBody.classList.add('rounded-top');
                content.classList.add('theme-' + THEME_TRANSPARENT); // overwrite defaults
            }
            content.append(contentBody);

            popup.append(overlay);
            popup.append(content);
            if (options.footer !== null) {
                var footer = options.footer.render();
                footer.style.zIndex = zIndex;
                popup.classList.add('fixed-footer');
                popup.append(footer);
            }
            content.style.zIndex = zIndex;
            popup.style.zIndex = zIndex;

            return popup;
        };
    }, { "./constant": 4 }] }, {}, [3]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var SIZE_SM = 'sm';
        var THEME_DEFAULT = 'default';
        var THEME_SECONDARY = 'secondary';
        var THEME_TRANSPARENT = 'transparent';
        var THEME_PRIMARY = 'primary';
        var TYPE_FULL = 'full';
        var TYPE_BOTTOM = 'bottom';
        var TYPE_FLOATING = 'floating';

        module.exports = {
            SIZE_SM: SIZE_SM,
            THEME_DEFAULT: THEME_DEFAULT,
            THEME_SECONDARY: THEME_SECONDARY,
            THEME_TRANSPARENT: THEME_TRANSPARENT,
            THEME_PRIMARY: THEME_PRIMARY,
            TYPE_FULL: TYPE_FULL,
            TYPE_BOTTOM: TYPE_BOTTOM,
            TYPE_FLOATING: TYPE_FLOATING
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var SIZE_SM = 'sm';
        var THEME_DEFAULT = 'default';
        var THEME_SECONDARY = 'secondary';
        var THEME_TRANSPARENT = 'transparent';
        var THEME_PRIMARY = 'primary';
        var TYPE_FULL = 'full';
        var TYPE_BOTTOM = 'bottom';
        var TYPE_FLOATING = 'floating';

        module.exports = {
            SIZE_SM: SIZE_SM,
            THEME_DEFAULT: THEME_DEFAULT,
            THEME_SECONDARY: THEME_SECONDARY,
            THEME_TRANSPARENT: THEME_TRANSPARENT,
            THEME_PRIMARY: THEME_PRIMARY,
            TYPE_FULL: TYPE_FULL,
            TYPE_BOTTOM: TYPE_BOTTOM,
            TYPE_FLOATING: TYPE_FLOATING
        };
    }, {}], 2: [function (require, module, exports) {
        var _require5 = require('./constant'),
            THEME_TRANSPARENT = _require5.THEME_TRANSPARENT;

        /**
         * @param {HtModalOptions} options
         * @param {number} zIndex
         * @return {HTMLDivElement}
         */


        module.exports = function (options, zIndex) {
            var _popup$classList3, _overlay$classList3, _contentBody$classLis3;

            var popup = document.createElement('div');
            popup.id = options.id;
            var typeClass = options.type ? "modal2--" + options.type : null;
            var parentClasses = typeof options.parentCssClass === 'string' ? options.parentCssClass.split(/\s+/).filter(Boolean) : [];
            (_popup$classList3 = popup.classList).add.apply(_popup$classList3, _toConsumableArray(['modal2', typeClass].concat(_toConsumableArray(parentClasses)).filter(Boolean)));

            var overlay = document.createElement('div');
            overlay.setAttribute('role', 'button');
            (_overlay$classList3 = overlay.classList).add.apply(_overlay$classList3, ['modal2-overlay', 'modal2-overlay--blurred', 'fade-animation']);

            var content = options.content.render();
            if (options.fixContentMaxHeight) {
                content.classList.add('fix-max-height');
            }

            var isContentBg = true;
            if (options.header) {
                if (options.header.isSticky()) {
                    popup.classList.add('fixed-header');
                }
                // header внутри content для sticky
                content.append(options.header.render());
                isContentBg = !options.header.isTransparent();
            }

            var contentBody = document.createElement('div');
            (_contentBody$classLis3 = contentBody.classList).add.apply(_contentBody$classLis3, ['modal2-body']);
            if (options.footer && options.footer.height !== null) {
                contentBody.style.paddingBottom = options.footer.height + 'px';
            }
            if (isContentBg) {
                content.classList.add('theme-' + options.content.theme);
            } else {
                contentBody.classList.add('theme-' + options.content.theme);
                contentBody.classList.add('rounded-top');
                content.classList.add('theme-' + THEME_TRANSPARENT); // overwrite defaults
            }
            content.append(contentBody);

            popup.append(overlay);
            popup.append(content);
            if (options.footer !== null) {
                var footer = options.footer.render();
                footer.style.zIndex = zIndex;
                popup.classList.add('fixed-footer');
                popup.append(footer);
            }
            content.style.zIndex = zIndex;
            popup.style.zIndex = zIndex;

            return popup;
        };
    }, { "./constant": 1 }] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var SIZE_SM = 'sm';
        var THEME_DEFAULT = 'default';
        var THEME_SECONDARY = 'secondary';
        var THEME_TRANSPARENT = 'transparent';
        var THEME_PRIMARY = 'primary';
        var TYPE_FULL = 'full';
        var TYPE_BOTTOM = 'bottom';
        var TYPE_FLOATING = 'floating';

        module.exports = {
            SIZE_SM: SIZE_SM,
            THEME_DEFAULT: THEME_DEFAULT,
            THEME_SECONDARY: THEME_SECONDARY,
            THEME_TRANSPARENT: THEME_TRANSPARENT,
            THEME_PRIMARY: THEME_PRIMARY,
            TYPE_FULL: TYPE_FULL,
            TYPE_BOTTOM: TYPE_BOTTOM,
            TYPE_FLOATING: TYPE_FLOATING
        };
    }, {}], 2: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var i18nMessages = {
            labelBackBtn: 'Закрыть',
            labelSelect: 'Выбрать'
        };

        var c = require('./constant');

        /**
         * @property {string} title
         * @property {string|null} titleSize - см. c.SIZE_{TYPE}
         * @property {string|null} titleFor
         * @property {'center'|'left'} titleAlign
         * @property {HTMLElement|string|null} html - custom content
         */

        var HtModalHeader = function () {
            function HtModalHeader(props) {
                _classCallCheck(this, HtModalHeader);

                this.title = props.title;
                this.titleSize = props.titleSize || null;
                this.titleFor = props.titleFor || null;
                this.titleAlign = props.titleAlign || 'center';
                this.html = props.html || null; // custom content
                this.theme = props.theme || c.THEME_DEFAULT;
            }

            _createClass(HtModalHeader, [{
                key: "isTransparent",
                value: function isTransparent() {
                    return this.theme === c.THEME_TRANSPARENT;
                }
            }, {
                key: "isSticky",
                value: function isSticky() {
                    return !this.isTransparent();
                }

                /** @return HTMLDivElement */

            }, {
                key: "render",
                value: function render() {
                    var _header$classList2;

                    var header = document.createElement('div');
                    (_header$classList2 = header.classList).add.apply(_header$classList2, ['modal2-header', 'theme-' + this.theme]);

                    if (this.isTransparent()) {
                        header.append(this.renderCloseButton());
                    } else {
                        header.classList.add('modal2-header--rounded');
                        if (this.isSticky()) {
                            header.classList.add('sticky');
                        }
                        header.innerHTML = this.renderTitle();
                        if (this.html !== null) {
                            var customContent = document.createElement('div');
                            customContent.classList.add('modal2-header__content'); // modal-header__content
                            customContent.classList.add('custom-content'); // modal-header__content
                            customContent.innerHTML = this.html;
                            header.append(customContent);
                        }
                    }

                    return header;
                }

                /**
                 * @private
                 * @return {HTMLDivElement}
                 */

            }, {
                key: "renderTitle",
                value: function renderTitle() {
                    var titleContent = void 0;
                    if (this.titleFor) {
                        titleContent = "<label class=\"modal2-title__label\" for=\"" + this.titleFor + "\">" + this.title + "</label>";
                    } else {
                        titleContent = this.title;
                    }

                    var classList = ['modal2-title', 'align-' + this.titleAlign]; // header-title => modal-title
                    if (this.titleSize !== null) {
                        classList.push('modal2-title--' + this.titleSize);
                    }
                    return '<div class="' + classList.join(' ') + ' text-ellipsis">' + titleContent + '</div>' + '<div class="aside-right">' + '<button type="button"' + ' class="modal2-header__close-circle modal2-close"' + ' aria-label="' + i18nMessages.labelBackBtn + '"></button>' + '</div>';
                }
            }, {
                key: "renderCloseButton",
                value: function renderCloseButton() {
                    var _button$classList3;

                    var button = document.createElement('button');
                    button.type = 'button';
                    (_button$classList3 = button.classList).add.apply(_button$classList3, ['modal2-header__close-cross', 'modal2-close']);
                    button.setAttribute('aria-label', i18nMessages.labelBackBtn);
                    return button;
                }
            }]);

            return HtModalHeader;
        }();

        /**
         * Одновременно можно использовать только 1 из доступных способов:
         * @property {HTMLElement|string} html - Значение будет выведено в качестве контента
         * @property {string} htmlDetachSelectorId - Элемент со страницы будет выведен в качестве контента
         * @property {string} url - Контент будет загружен отложено
         * @property {string} theme - Тема модалки
         */


        var HtModalContent = function () {
            function HtModalContent(props) {
                _classCallCheck(this, HtModalContent);

                this.html = props.html || '';
                this.htmlDetachSelectorId = props.htmlDetachSelectorId || '';
                this.url = props.url || '';
                this.theme = props.theme || c.THEME_DEFAULT;
            }

            /** @return {HTMLDivElement} */


            _createClass(HtModalContent, [{
                key: "render",
                value: function render() {
                    var _content$classList2;

                    var content = document.createElement('div');
                    (_content$classList2 = content.classList).add.apply(_content$classList2, ['modal2-content']);
                    return content;
                }
            }]);

            return HtModalContent;
        }();

        /**
         * @property {string} theme
         * @property {string} buttonLabel
         * @property {string} buttonCssClass
         * @property {number|null} height
         */


        var HtModalFooter = function () {
            function HtModalFooter(props) {
                _classCallCheck(this, HtModalFooter);

                this.theme = props.theme || c.THEME_DEFAULT;
                this.buttonLabel = props.buttonLabel || i18nMessages.labelSelect;
                this.buttonCssClass = props.buttonCssClass || '';
                this.height = props.height || null;
            }

            /** @return {HTMLDivElement} */


            _createClass(HtModalFooter, [{
                key: "render",
                value: function render() {
                    var _footer$classList2;

                    var footer = document.createElement('div');
                    (_footer$classList2 = footer.classList).add.apply(_footer$classList2, ['modal2-footer', 'fade-animation', 'theme-' + this.theme]);
                    footer.append(this.renderButton());

                    return footer;
                }

                /**
                 * @private
                 * @return {HTMLButtonElement}
                 */

            }, {
                key: "renderButton",
                value: function renderButton() {
                    var _button$classList4;

                    var button = document.createElement('button');
                    button.type = 'button';
                    var classList = 'btn btn-blue modal2-close';
                    if (this.buttonCssClass !== '') {
                        classList += ' ' + this.buttonCssClass;
                    }
                    classList = classList.trim().split(' ');
                    (_button$classList4 = button.classList).add.apply(_button$classList4, _toConsumableArray(classList));
                    button.innerHTML = this.buttonLabel;

                    return button;
                }
            }, {
                key: "getCssHeight",
                value: function getCssHeight() {
                    if (this.height === null) {
                        return null;
                    }
                    return this.height + 'px';
                }
            }]);

            return HtModalFooter;
        }();

        /**
         * @property {string} id - Selecor ID модалки.
         *  Для обратной совместимости с формой поиска.
         *  Нежелательно передавать снаружи
         * @property {HtModalContent} content - настройки отображения контента
         * @property {HtModalHeader|null} header - настройки отображения шапки
         * @property {HtModalFooter|null} footer - настройки отображения футера
         * @property {Function|null} onAfterShow - колбек перед началом показа
         * @property {Function|null} onBeforeClose - колбек перед закрытием
         * @property {Function|null} onBeforeRemove - колбек перед удалением из DOM
         */


        var HtModalOptions = function () {
            function HtModalOptions(props) {
                _classCallCheck(this, HtModalOptions);

                // required
                this.header = props.header;
                this.content = props.content;
                this.animationDuration = props.animationDuration || 400;
                // optional
                this.id = props.id || this.randomId();
                this.type = props.type || c.TYPE_BOTTOM;
                this.parentCssClass = props.parentCssClass || '';
                this.fixContentMaxHeight = props.fixContentMaxHeight || false;
                this.footer = props.footer || null;
                this.onAfterShow = typeof props.onAfterShow === 'function' ? props.onAfterShow : null;
                this.onBeforeClose = typeof props.onBeforeClose === 'function' ? props.onBeforeClose : null;
                this.onBeforeRemove = typeof props.onBeforeRemove === 'function' ? props.onBeforeRemove : null;
            }

            _createClass(HtModalOptions, [{
                key: "randomId",
                value: function randomId() {
                    return 'modal2--id-' + new Date().getTime() + '-' + Math.ceil(Math.random() * 1000);
                }
            }, {
                key: "validate",
                value: function validate() {
                    return this.content.html || this.content.htmlDetachSelectorId || this.content.url;
                }
            }]);

            return HtModalOptions;
        }();

        /**
         * Построение конфигурации из объекта
         * @param optionsConfig
         * @return {HtModalOptions}
         */


        function buildHtModalOptions(optionsConfig) {
            if (optionsConfig instanceof HtModalOptions) {
                return optionsConfig;
            }

            var footer = null;
            if (optionsConfig.footer) {
                footer = new HtModalFooter(optionsConfig.footer);
            }
            var header = null;
            if (optionsConfig.header) {
                header = new HtModalHeader(optionsConfig.header);
            }

            return new HtModalOptions({
                id: optionsConfig.id,
                type: optionsConfig.type,
                parentCssClass: optionsConfig.parentCssClass,
                animationDuration: optionsConfig.animationDuration || null,
                // sections
                header: header,
                footer: footer,
                content: new HtModalContent(optionsConfig.content),
                // settings
                fixContentMaxHeight: optionsConfig.fixContentMaxHeight || null,
                // callbacks
                onAfterShow: optionsConfig.onAfterShow || null,
                onBeforeClose: optionsConfig.onBeforeClose || null,
                onBeforeRemove: optionsConfig.onBeforeRemove || null
            });
        }

        module.exports = {
            build: buildHtModalOptions,
            themes: {
                DEFAULT: c.THEME_DEFAULT,
                SECONDARY: c.THEME_SECONDARY,
                TRANSPARENT: c.THEME_TRANSPARENT,
                PRIMARY: c.THEME_PRIMARY
            },
            sizes: {
                SM: c.SIZE_SM
            },
            types: {
                FULL: c.TYPE_FULL,
                BOTTOM: c.TYPE_BOTTOM,
                FLOATING: c.TYPE_FLOATING
            }
        };
    }, { "./constant": 1 }] }, {}, [2]);